webpackJsonp([1],{

/***/ 1085:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1089:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1090:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1091:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1092:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1093:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1094:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1095:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1096:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1098:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1099:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1100:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1102:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1108:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1111:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1112:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1113:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1114:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1128:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1099)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1163),
  /* scopeId */
  "data-v-377e32fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1108)
__webpack_require__(1109)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1171),
  /* scopeId */
  "data-v-60c6b540",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1106)

var Component = __webpack_require__(14)(
  /* script */
  null,
  /* template */
  __webpack_require__(1169),
  /* scopeId */
  "data-v-552f9c87",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1105)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1168),
  /* scopeId */
  "data-v-51a2c380",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1094)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1158),
  /* scopeId */
  "data-v-2c8a1058",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1087)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1151),
  /* scopeId */
  "data-v-18ae9bcc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1134:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1089)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1153),
  /* scopeId */
  "data-v-202c066e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1135:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1091)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1155),
  /* scopeId */
  "data-v-23e323a3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1114)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1176),
  /* scopeId */
  "data-v-d6bdf2ce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1090)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1154),
  /* scopeId */
  "data-v-2073a32c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1138:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1107)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1170),
  /* scopeId */
  "data-v-60b93920",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1098)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1162),
  /* scopeId */
  "data-v-335389a7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1110)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1172),
  /* scopeId */
  "data-v-674cb081",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1141:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1113)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1175),
  /* scopeId */
  "data-v-c713ce70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1142:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1085)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1149),
  /* scopeId */
  "data-v-04158472",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1095)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1159),
  /* scopeId */
  "data-v-2db86b99",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1096)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1160),
  /* scopeId */
  "data-v-2e20f010",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1145:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1112)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1174),
  /* scopeId */
  "data-v-a47fd5f6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1146:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1104)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1167),
  /* scopeId */
  "data-v-4cd9f635",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1101)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1165),
  /* scopeId */
  "data-v-46366051",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1148:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1100)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1164),
  /* scopeId */
  "data-v-3e440d5e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "修改帐户&密码",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "warings"
  }, [_vm._v(" 用户名只能使用修改一次, 请认真思考后再修改")]), _vm._v(" "), _c('div', {
    staticClass: "warings"
  }, [_vm._v(" 修改后即可使用用户名密码登录")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newpass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.newpass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "newpass", $$v)
      },
      expression: "formData.newpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重复密码",
      "prop": "repass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.repass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "repass", $$v)
      },
      expression: "formData.repass"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "充值VIP",
      "width": "500px",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      },
      "close": _vm.closeFun
    }
  }, [_c('div', [_c('div', {
    staticClass: "contDiv"
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "tits"
  }, [_vm._v("VIP 1")]), _vm._v(" "), _c('div', {
    staticClass: "pay-wars"
  }, [_vm._v("目前仅支持余额扣款!!!")]), _vm._v(" "), _c('div', {
    staticClass: "conts"
  }, [_vm._v("2 TB")]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('el-button', {
    staticClass: "chongBtn",
    attrs: {
      "type": "warning",
      "loading": _vm.submiting
    },
    on: {
      "click": function($event) {
        return _vm.chongVipFun(1, 1)
      }
    }
  }, [_vm._v("15元/月")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('el-button', {
    staticClass: "chongBtn",
    attrs: {
      "type": "danger",
      "loading": _vm.submiting
    },
    on: {
      "click": function($event) {
        return _vm.chongVipFun(1, 12)
      }
    }
  }, [_vm._v("150元/年")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "tits"
  }, [_vm._v("VIP 2")]), _vm._v(" "), _c('div', {
    staticClass: "pay-wars"
  }, [_vm._v("目前仅支持余额扣款!!!")]), _vm._v(" "), _c('div', {
    staticClass: "conts"
  }, [_vm._v("5 TB")]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('el-button', {
    staticClass: "chongBtn",
    attrs: {
      "type": "warning",
      "loading": _vm.submiting
    },
    on: {
      "click": function($event) {
        return _vm.chongVipFun(2, 1)
      }
    }
  }, [_vm._v("30元/月")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('el-button', {
    staticClass: "chongBtn",
    attrs: {
      "type": "danger",
      "loading": _vm.submiting
    },
    on: {
      "click": function($event) {
        return _vm.chongVipFun(2, 12)
      }
    }
  }, [_vm._v("300元/年")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "infotxts"
  }, [_c('ul', [_c('li', [_vm._v("空间大小会随"), _c('span', {
    staticStyle: {
      "color": "#fd8f1c"
    }
  }, [_vm._v("上个月收入而变化")]), _vm._v(": !")]), _vm._v(" "), _c('li', [_vm._v("默认为 "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("50GB")]), _vm._v(" ! ! !")]), _vm._v(" "), _c('li', [_vm._v("如果上个月收入大于 "), _c('span', {
    staticStyle: {
      "color": "#f60"
    }
  }, [_vm._v("500")]), _vm._v(",则空间为 "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("100GB")]), _vm._v(" !")]), _vm._v(" "), _c('li', [_vm._v("如果上个月收入大于 "), _c('span', {
    staticStyle: {
      "color": "#f60"
    }
  }, [_vm._v("1000")]), _vm._v(",则空间为 "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("200GB")]), _vm._v(" !")]), _vm._v(" "), _c('li', [_vm._v("如果上个月收入大于 "), _c('span', {
    staticStyle: {
      "color": "#f60"
    }
  }, [_vm._v("2000")]), _vm._v(",则空间为 "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("300GB")]), _vm._v(" !")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1151:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('el-card', {
    staticClass: "box-card infobox"
  }, [_c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("用户名："), _c('a', {
    attrs: {
      "target": "_blank",
      "href": 'http://jazpan.com/user/' + _vm.getUserInfo.uid
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getUserInfo.name) + "\n          ")]), _vm._v(" "), (_vm.getUserInfo.tmpname == 1) ? _c('i', {
    staticClass: "el-icon-edit-outline",
    staticStyle: {
      "cursor": "pointer",
      "color": "red",
      "font-weight": "bold"
    },
    attrs: {
      "alt": "可使用密码登录"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.NameForm.show()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("ID：" + _vm._s(_vm.getUserInfo.uid))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("昵称：" + _vm._s(_vm.getUserInfo.nick))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("注册时间：" + _vm._s(_vm.getUserInfo.times))])], 1), _vm._v(" "), (_vm.balances > 0.0 || _vm.balancetx > 0.0) ? _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("余额："), _c('span', {
    staticClass: "amountxs"
  }, [_vm._v(_vm._s(_vm.balances))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("正在提现："), _c('span', {
    staticClass: "amountxs"
  }, [_vm._v(_vm._s(_vm.balancetx))])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("VIP1："), _c('span', [_vm._v(_vm._s(_vm.getUserInfo.vip1))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("VIP2："), _c('span', [_vm._v(_vm._s(_vm.getUserInfo.vip2))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_vm._v("\n        简介：" + _vm._s(_vm.getUserInfo.desc) + "\n      ")]), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.proEdit.show()
      }
    }
  }, [_vm._v("修改资料")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.avatEdit.show()
      }
    }
  }, [_vm._v("修改头像")]), _vm._v(" "), (_vm.balances > 0.0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.chongVipDlg.show()
      }
    }
  }, [_vm._v("充值VIP")]) : _vm._e(), _vm._v(" "), (_vm.balances > 0.0) ? _c('el-button', {
    attrs: {
      "type": "warning",
      "size": "small"
    },
    on: {
      "click": _vm.tixianFun
    }
  }, [_vm._v("提现")]) : _vm._e(), _vm._v(" "), (_vm.balances > 0.0) ? _c('el-button', {
    attrs: {
      "type": "info",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/txs')
      }
    }
  }, [_vm._v("提现记录")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.balances > 0.0),
      expression: "balances > 0.0"
    }],
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('el-card', {
    staticClass: "box-card chartsbox"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": "blChart1"
    }
  })]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card chartsbox"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": "blChart2"
    }
  })])], 1), _vm._v(" "), _c('NameForm', {
    ref: "NameForm"
  }), _vm._v(" "), _c('proEdit', {
    ref: "proEdit"
  }), _vm._v(" "), _c('avatEdit', {
    ref: "avatEdit"
  }), _vm._v(" "), _c('txEdit', {
    ref: "txEdit",
    on: {
      "submitOK": function($event) {
        return _vm.getBalances()
      }
    }
  }), _vm._v(" "), _c('txTaxEdit', {
    ref: "txTaxEdit",
    on: {
      "submitOK": function($event) {
        return _vm.getBalances()
      }
    }
  }), _vm._v(" "), _c('ChongVip', {
    ref: "chongVipDlg",
    on: {
      "submitOK": function($event) {
        return _vm.refreshPg()
      }
    }
  }), _vm._v(" "), _c('ChongZhi', {
    ref: "chongZhiDlg",
    on: {
      "submitOK": function($event) {
        return _vm.refreshPg()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1152:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "修改资料",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称",
      "prop": "nick"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.nick),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nick", $$v)
      },
      expression: "formData.nick"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.desc),
      callback: function($$v) {
        _vm.$set(_vm.formData, "desc", $$v)
      },
      expression: "formData.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系微信"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.wxname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "wxname", $$v)
      },
      expression: "formData.wxname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1153:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "修改信息",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "排序",
      "prop": "sort"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.sort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sort", $$v)
      },
      expression: "formData.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.desc),
      callback: function($$v) {
        _vm.$set(_vm.formData, "desc", $$v)
      },
      expression: "formData.desc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1154:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mainDiv"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upShow),
      expression: "upShow"
    }],
    staticClass: "leftDiv"
  }, [_c('Upload', {
    on: {
      "okfun": function($event) {
        return _vm.getList()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "rightDiv",
    staticClass: "rightDiv",
    style: ('width:' + _vm.upShowRW)
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.listQuery
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleHide
    }
  }, [_vm._v(_vm._s(_vm.upShow ? '隐藏' : '显示') + "上传面板")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "搜索"
    },
    model: {
      value: (_vm.listQuery.q),
      callback: function($$v) {
        _vm.$set(_vm.listQuery, "q", $$v)
      },
      expression: "listQuery.q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getList()
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-link', {
    attrs: {
      "type": "primary",
      "href": "https://mp.weixin.qq.com/s/NhYs51XBuWYvy9uRDXRBkw",
      "target": "_blank"
    }
  }, [_vm._v("上传资料操作指南")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "dataTable",
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "Loading",
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.changeSortFun
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Stats))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.Status < 1) ? _c('span', [_vm._v(_vm._s(row.Name))]) : (row.Sh == 2) ? _c('span', [_vm._v(_vm._s(row.Name) + " "), _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("(审核未通过)")])]) : _c('a', {
          attrs: {
            "href": 'http://jazpan.com/view/' + row.Id,
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "flicon",
          attrs: {
            "src": _vm.$ApiUrl + '/icon?name=' + row.Extion
          }
        }), _vm._v("\n              " + _vm._s(row.Name) + "\n            ")]), _vm._v("   "), (row.infoMap.pined == true) ? _c('a', {
          staticStyle: {
            "font-size": "11px",
            "color": "red"
          },
          attrs: {
            "target": "_blank",
            "href": 'http://jazpan.com/user/' + row.Uid
          }
        }, [_vm._v("[置顶]")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticStyle: {
            "color": "#f60",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(row.Amounts))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "大小",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.getFlSize(row.Size)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Pays",
      "label": "付款",
      "align": "center",
      "width": "80px",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Downs",
      "label": "下载",
      "align": "center",
      "width": "80px",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Timestr))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('img', {
          staticClass: "btnQr",
          attrs: {
            "src": "//static.jazpan.com/img/qrcode.png"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.qrcoder.show('https://jazpan.com/view/' + row.Id, 'https://m.jazpan.com/xcx/qrgoto/file?' + row.Id)
            }
          }
        }), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "加入我的文件夹",
            "placement": "top"
          }
        }, [_c('img', {
          staticClass: "btnQr",
          attrs: {
            "src": "//static.jazpan.com/img/flbox.png"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.boxSelForm.show(null, row.Xid)
            }
          }
        })]), _vm._v(" "), _c('i', {
          staticClass: "btnQr el-icon-edit-outline",
          staticStyle: {
            "color": "#db3939"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.fileEdit.show(row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "btnQr el-icon-delete",
          staticStyle: {
            "color": "#db3939"
          },
          on: {
            "click": function($event) {
              return _vm.delFun(row.Xid)
            }
          }
        }), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": (row.infoMap.pined == true ? '取消置顶' : '置顶') + '在个人主页',
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "btnQr el-icon-top",
          staticStyle: {
            "color": "#db3939"
          },
          on: {
            "click": function($event) {
              return _vm.pinUserFun(row.Xid)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "50px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.pgpage,
      "page-count": _vm.pgpages
    },
    on: {
      "current-change": _vm.getList
    }
  })], 1)], 1), _vm._v(" "), _c('FileEdit', {
    ref: "fileEdit",
    on: {
      "submitOK": function($event) {
        return _vm.getList()
      }
    }
  }), _vm._v(" "), _c('BoxSelForm', {
    ref: "boxSelForm",
    on: {
      "submitOK": function($event) {
        return _vm.getList()
      }
    }
  }), _vm._v(" "), _c('Qrcode', {
    ref: "qrcoder",
    attrs: {
      "showtips": true
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1155:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mainDiv"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upShow),
      expression: "upShow"
    }],
    staticClass: "leftDiv"
  }, [(_vm.box) ? _c('div', {
    staticClass: "boxDiv"
  }, [_vm._v("文件夹："), _c('a', {
    attrs: {
      "href": 'http://jazpan.com/box/' + _vm.box.Id,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.box.Name))]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-circle-close",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.clearBox()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "btnQr",
    attrs: {
      "src": "//static.jazpan.com/img/qrcode.png"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.qrcoder.show('https://jazpan.com/box/' + _vm.box.Id, 'https://m.jazpan.com/xcx/qrgoto/box?' + _vm.box.Id)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Upload', {
    attrs: {
      "boxid": _vm.boxid
    },
    on: {
      "okfun": function($event) {
        return _vm.getList()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "rightDiv",
    staticClass: "rightDiv",
    style: ('width:' + _vm.upShowRW)
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.listQuery
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleHide
    }
  }, [_vm._v(_vm._s(_vm.upShow ? '隐藏' : '显示') + "上传面板")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "搜索"
    },
    model: {
      value: (_vm.listQuery.q),
      callback: function($$v) {
        _vm.$set(_vm.listQuery, "q", $$v)
      },
      expression: "listQuery.q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getList();
        _vm.getBoxList();
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.fileSelForm.show(_vm.boxid)
      }
    }
  }, [_vm._v("添加文件")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.boxSelForm.show(_vm.boxid)
      }
    }
  }, [_vm._v("添加文件夹")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onKeySortFun
    }
  }, [_vm._v("一键排序文件")])], 1)], 1)], 1), _vm._v(" "), (_vm.tableData.length > 100 || _vm.boxlistData.length > 100) ? _c('div', {
    staticClass: "tips"
  }, [_vm._v("提示: 文件夹只能显示100个文件，超过的部分将不会显示出来")]) : _vm._e(), _vm._v(" "), (_vm.boxlistData.length > 0) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.boxlistLoading),
      expression: "boxlistLoading"
    }],
    ref: "boxdataTable",
    attrs: {
      "data": _vm.boxlistData,
      "element-loading-text": "Loading",
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.changeSortFun
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    }
  }, [
    [_c('span', [_vm._v("正常")])]
  ], 2), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件夹",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.Status < 1) ? _c('span', [_vm._v(_vm._s(row.Name))]) : _c('a', {
          attrs: {
            "href": 'http://jazpan.com/box/' + row.Id,
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "flicon",
          attrs: {
            "src": "//static.jazpan.com/img/flbox.png"
          }
        }), _vm._v("\n              " + _vm._s(row.Name) + "\n            ")])]
      }
    }], null, false, 490592504)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Timestr))])]
      }
    }], null, false, 790294596)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Sort",
      "label": "排序",
      "align": "center",
      "width": "50px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('img', {
          staticClass: "btnQr",
          attrs: {
            "src": "//static.jazpan.com/img/qrcode.png"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.qrcoder.show('https://jazpan.com/box/' + row.Id, 'https://m.jazpan.com/xcx/qrgoto/box?' + row.Id)
            }
          }
        }), _vm._v(" "), (row.Canedit) ? _c('el-link', {
          staticClass: "btnTxt",
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.inits(row.Xid)
            }
          }
        }, [_vm._v("管理")]) : _vm._e(), _vm._v(" "), _c('el-link', {
          staticClass: "btnTxt",
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.$refs.boxSelfForm.show(row)
            }
          }
        }, [_vm._v("排序")]), _vm._v(" "), _c('el-link', {
          staticClass: "btnTxt",
          attrs: {
            "type": "warning",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.rmBoxFun(row.Prtid, row.Xid)
            }
          }
        }, [_vm._v("移除")])]
      }
    }], null, false, 4287312606)
  })], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "dataTable",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "Loading",
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.changeSortFun
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Stats))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件名",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.Status < 1) ? _c('span', [_vm._v(_vm._s(row.Name))]) : _c('a', {
          attrs: {
            "href": 'http://jazpan.com/view/' + row.Id,
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "flicon",
          attrs: {
            "src": _vm.$ApiUrl + '/icon?name=' + row.Extion
          }
        }), _vm._v("\n              " + _vm._s(row.Name) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticStyle: {
            "color": "#f60",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(row.Amounts))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "大小",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.getFlSize(row.Size)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Downs",
      "label": "下载",
      "align": "center",
      "width": "80px",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Timestr))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Sort",
      "label": "排序",
      "align": "center",
      "width": "50px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('img', {
          staticClass: "btnQr",
          attrs: {
            "src": "//static.jazpan.com/img/qrcode.png"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.qrcoder.show('https://jazpan.com/view/' + row.Id, 'https://m.jazpan.com/xcx/qrgoto/file?' + row.Id)
            }
          }
        }), _vm._v(" "), (row.Canedit) ? _c('i', {
          staticClass: "btnQr el-icon-edit-outline",
          staticStyle: {
            "color": "#db3939"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.fileEdit.show(row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (row.Canedit) ? _c('i', {
          staticClass: "btnQr el-icon-delete",
          staticStyle: {
            "color": "#db3939"
          },
          on: {
            "click": function($event) {
              return _vm.delFun(row.Xid)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('el-link', {
          staticClass: "btnTxt",
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.$refs.boxflEdit.show(row)
            }
          }
        }, [_vm._v("排序")]), _vm._v(" "), _c('el-link', {
          staticClass: "btnTxt",
          attrs: {
            "type": "warning",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.rmFun(row.Boxid, row.Xid)
            }
          }
        }, [_vm._v("移除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "50px"
    }
  })], 1), _vm._v(" "), _c('FileEdit', {
    ref: "fileEdit",
    on: {
      "submitOK": function($event) {
        return _vm.getList()
      }
    }
  }), _vm._v(" "), _c('BoxFileForm', {
    ref: "boxflEdit",
    on: {
      "submitOK": function($event) {
        return _vm.getList()
      }
    }
  }), _vm._v(" "), _c('BoxSelfForm', {
    ref: "boxSelfForm",
    on: {
      "submitOK": function($event) {
        return _vm.getBoxList()
      }
    }
  }), _vm._v(" "), _c('FileSelForm', {
    ref: "fileSelForm",
    on: {
      "submitOK": function($event) {
        return _vm.getList()
      }
    }
  }), _vm._v(" "), _c('BoxSelForm', {
    ref: "boxSelForm",
    on: {
      "submitOK": function($event) {
        return _vm.getBoxList()
      }
    }
  }), _vm._v(" "), _c('Qrcode', {
    ref: "qrcoder"
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1156:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submiting
    },
    on: {
      "click": _vm.upSubmit
    }
  }, [_vm._v("开始上传")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.upload.clearFiles()
      }
    }
  }, [_vm._v("清空列表")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "选择分类"
    },
    model: {
      value: (_vm.fenlei),
      callback: function($$v) {
        _vm.fenlei = $$v
      },
      expression: "fenlei"
    }
  }, _vm._l((_vm.fenleis), function(fl) {
    return _c('el-option', {
      key: 'fl1-' + fl.Id,
      attrs: {
        "label": fl.Name,
        "value": fl.Id + ''
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-top": "10px",
      "margin-left": "10px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "统一金额"
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "placement": "right"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("如果有用户投诉文件有密码等"), _c('span', {
    staticStyle: {
      "color": "#e20101"
    }
  }, [_vm._v("无法使用的情况")]), _vm._v("，经客服核实后"), _c('br'), _vm._v("\n          会发起全额退款，包括用户下载产生的流量费也"), _c('span', {
    staticStyle: {
      "color": "#e20101"
    }
  }, [_vm._v("由该作者承担")])])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s/NhYs51XBuWYvy9uRDXRBkw",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "10px",
      "width": "100%",
      "height": "35px"
    },
    attrs: {
      "src": "//static.jazpan.com/img/scznx.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xtips"
  }, [_vm._v("\n          小提示：请不要上传有密码等有限制的文件\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "xtips"
  }, [_c('a', {
    attrs: {
      "href": "https://jazpan.com/cmt/t/26",
      "target": "_blank"
    }
  }, [_vm._v("Windows App 可以上传超过2G的文件")])])])])], 1), _vm._v(" "), _c('div', [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "upfile",
      "drag": "",
      "multiple": "",
      "auto-upload": false,
      "action": _vm.uploadActUrl,
      "before-upload": _vm.handleBeforeUpload,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess
    },
    on: {
      "update:action": function($event) {
        _vm.uploadActUrl = $event
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击选择文件")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  })])], 1), _vm._v(" "), _c('proEdit', {
    ref: "proEdit"
  }), _vm._v(" "), _c('ChongVip', {
    ref: "chongVipDlg",
    on: {
      "submitOK": function($event) {
        return _vm.$refs.chongVipDlg.close()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1157:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1158:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-page"
  }, [_c('div', {
    staticClass: "login-form-box"
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('div', {
    staticClass: "hdiv"
  }, [_c('a', {
    attrs: {
      "href": "http://jazpan.com"
    }
  }, [_c('img', {
    staticClass: "hdlogo",
    attrs: {
      "src": "//static.jazpan.com/img/logo1.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tit"
  }, [_vm._v("夹子盘登录")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登录\n          ")])], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "login-link-box"
  }, [_c('div', [_vm._v("记住我\n              "), _c('el-switch', {
    model: {
      value: (_vm.ruleForm2.remember),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "remember", $$v)
      },
      expression: "ruleForm2.remember"
    }
  })], 1), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://jazpan.com"
    }
  }, [_vm._v("忘记密码")])])]), _vm._v(" "), _c('div', {
    staticClass: "login-wxlg",
    on: {
      "click": function($event) {
        return _vm.$refs.wxLoginDlg.show()
      }
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/weixinlg.png"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("微信登录")])])])], 1)], 1)]), _vm._v(" "), _c('WxLoginDlg', {
    ref: "wxLoginDlg",
    on: {
      "submitOK": function($event) {
        return _vm.$router.push(_vm.redirect || '/')
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1159:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入订单号查询"
    },
    model: {
      value: (_vm.filters.q),
      callback: function($$v) {
        _vm.$set(_vm.filters, "q", $$v)
      },
      expression: "filters.q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": "info"
    }
  }, [_vm._v("只显示两年内的信息")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listdata,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('a', {
          attrs: {
            "target": "_blank",
            "href": '//jazpan.com/view/' + (row.infoMap.fid || row.Fid)
          }
        }, [_vm._v(_vm._s(row.infoMap.fname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticClass: "amountxs"
        }, [_vm._v(_vm._s(row.infoMap.flamts))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单ID",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-popover', {
          attrs: {
            "placement": "top-start",
            "title": "订单号",
            "width": "200",
            "trigger": "hover",
            "content": '[' + row.Mxid + ']: ' + row.Mchid
          }
        }, [_c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(row.Mxid))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下载人",
      "width": "135",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Ips))]), _vm._v(" "), (row.Uid != '') ? _c('p', [_c('a', {
          attrs: {
            "target": "_blank",
            "href": '//jazpan.com/user/' + row.Uid
          }
        }, [_vm._v("\n              " + _vm._s(row.infoMap.nick) + "\n            ")])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.Stat == -1) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("禁止下载")]) : (row.Stat == 0) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("未下载")]) : (row.Stat == 1) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("下载中")]) : (row.Stat == 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已下载")]) : _c('el-tag', [_vm._v(_vm._s(row.Stat))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "大小",
      "width": "120px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v("\n            " + _vm._s(_vm.getFlSize(row.Sizeln)) + "\n          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下载时间",
      "width": "180px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Timestr))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button-group')]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.filters.page,
      "total": _vm.total,
      "page-size": _vm.limit
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "current-change": _vm.getList
    }
  }), _vm._v(" "), _c('txTaxTips', {
    ref: "txTaxTips"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1160:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旧密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.pass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pass", $$v)
      },
      expression: "formData.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newpass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.newpass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "newpass", $$v)
      },
      expression: "formData.newpass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重复密码",
      "prop": "repass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.repass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "repass", $$v)
      },
      expression: "formData.repass"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1161:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "文件编辑",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类",
      "prop": "fenlei"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择分类"
    },
    model: {
      value: (_vm.formData.fenlei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fenlei", $$v)
      },
      expression: "formData.fenlei"
    }
  }, _vm._l((_vm.fenleis), function(fl) {
    return _c('el-option', {
      key: 'fl1-' + fl.Id,
      attrs: {
        "label": fl.Name,
        "value": fl.Id + ''
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "金额",
      "prop": "amount"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.amount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amount", $$v)
      },
      expression: "formData.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "加密"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.formData.jm),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jm", $$v)
      },
      expression: "formData.jm"
    }
  }), _vm._v(" "), (_vm.formData.jm) ? _c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.formData.pass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pass", $$v)
      },
      expression: "formData.pass"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.descpt),
      callback: function($$v) {
        _vm.$set(_vm.formData, "descpt", $$v)
      },
      expression: "formData.descpt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1162:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "文件夹编辑",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类",
      "prop": "fenlei"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择分类"
    },
    model: {
      value: (_vm.formData.fenlei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fenlei", $$v)
      },
      expression: "formData.fenlei"
    }
  }, _vm._l((_vm.fenleis), function(fl) {
    return _c('el-option', {
      key: 'fl1-' + fl.Id,
      attrs: {
        "label": fl.Name,
        "value": fl.Id + ''
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.desc),
      callback: function($$v) {
        _vm.$set(_vm.formData, "desc", $$v)
      },
      expression: "formData.desc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1163:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "充值余额",
      "width": "500px",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      },
      "close": _vm.closeFun
    }
  }, [_c('div', [_c('div', {
    staticClass: "contDiv"
  }, [_c('div', {
    staticStyle: {
      "width": "100px",
      "padding": "10px 0"
    }
  }, [_vm._v("充值金额")]), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入充值金额",
      "disabled": _vm.submiting
    },
    model: {
      value: (_vm.amtsVal),
      callback: function($$v) {
        _vm.amtsVal = $$v
      },
      expression: "amtsVal"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "chongBtn",
    attrs: {
      "type": "warning",
      "disabled": _vm.submiting
    },
    on: {
      "click": _vm.chongZhiFun
    }
  }, [_vm._v("确定充值")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submiting),
      expression: "submiting"
    }],
    staticClass: "wxpaydv"
  }, [_c('div', {
    staticClass: "pay-wars"
  }, [_vm._v("支付过程中请勿刷新页面或关闭浏览器!!!")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    ref: "qrcodeDiv",
    staticClass: "wxqrcode"
  }), _vm._v(" "), _c('div', {
    staticClass: "payleft"
  }, [_c('div', {
    staticClass: "wxpayamt"
  }, [_vm._v("￥" + _vm._s(_vm.amtsVal))]), _vm._v(" "), _c('div', {
    staticClass: "wxpayimg"
  }, [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/wxpayx.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/alipayx.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_vm._v("微信 & 支付宝 扫码支付")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "infotxts"
  }, [_c('ul', [_c('li', [_vm._v("付款后不支持退款 ! ! !")])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    on: {
      "click": _vm.checkFun
    }
  }, [_vm._v("我已支付完成")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1164:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "提现申请",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.istips),
      expression: "istips"
    }],
    staticClass: "divEWM"
  }, [_vm._v("你的收入已经被评估为专家，不再支持二维码提现，此后将以转账的形式提现"), _c('br'), _c('span', [_vm._v("如有疑问请关注公众号联系客服")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFs),
      expression: "showFs"
    }],
    attrs: {
      "label": "方式"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.infos.fs),
      callback: function($$v) {
        _vm.$set(_vm.formData.infos, "fs", $$v)
      },
      expression: "formData.infos.fs"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "geren"
    }
  }, [_vm._v("个人")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "qiye"
    }
  }, [_vm._v("企业")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "ali"
    }
  }, [_vm._v("支付宝")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "金额",
      "prop": "amt"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.amt),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amt", $$v)
      },
      expression: "formData.amt"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.infos.fs == 'geren'),
      expression: "formData.infos.fs == 'geren'"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "idname"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.infos.idname),
      callback: function($$v) {
        _vm.$set(_vm.formData.infos, "idname", $$v)
      },
      expression: "formData.infos.idname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份号",
      "prop": "idcard"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.infos.idcard),
      callback: function($$v) {
        _vm.$set(_vm.formData.infos, "idcard", $$v)
      },
      expression: "formData.infos.idcard"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行卡",
      "prop": "banknum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "姓名、地址必须和银行帐户能对上，否则可能转账失败",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.infos.banknum),
      callback: function($$v) {
        _vm.$set(_vm.formData.infos, "banknum", $$v)
      },
      expression: "formData.infos.banknum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行",
      "prop": "bankaddr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "开户行地址",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.infos.bankaddr),
      callback: function($$v) {
        _vm.$set(_vm.formData.infos, "bankaddr", $$v)
      },
      expression: "formData.infos.bankaddr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.infos.fs == 'qiye'),
      expression: "formData.infos.fs == 'qiye'"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "qyname"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.infos.qyname),
      callback: function($$v) {
        _vm.$set(_vm.formData.infos, "qyname", $$v)
      },
      expression: "formData.infos.qyname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "统一信用码",
      "label-width": "100px",
      "prop": "qynum"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.infos.qynum),
      callback: function($$v) {
        _vm.$set(_vm.formData.infos, "qynum", $$v)
      },
      expression: "formData.infos.qynum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行帐户",
      "prop": "banknum"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "名称、地址必须和银行帐户能对上，否则可能转账失败",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.infos.banknum),
      callback: function($$v) {
        _vm.$set(_vm.formData.infos, "banknum", $$v)
      },
      expression: "formData.infos.banknum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行",
      "prop": "bankaddr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "开户行地址",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.infos.bankaddr),
      callback: function($$v) {
        _vm.$set(_vm.formData.infos, "bankaddr", $$v)
      },
      expression: "formData.infos.bankaddr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.infos.fs == 'ali'),
      expression: "formData.infos.fs == 'ali'"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "支付宝",
      "prop": "aliid"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.infos.aliid),
      callback: function($$v) {
        _vm.$set(_vm.formData.infos, "aliid", $$v)
      },
      expression: "formData.infos.aliid"
    }
  }), _vm._v(" "), _c('div', [_c('el-tag', {
    attrs: {
      "type": "info",
      "size": "mini"
    }
  }, [_vm._v("请到支付宝个人中心查看准确的登录账号（一般是手机号或邮箱）")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "aliname"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.infos.aliname),
      callback: function($$v) {
        _vm.$set(_vm.formData.infos, "aliname", $$v)
      },
      expression: "formData.infos.aliname"
    }
  }), _vm._v(" "), _c('div', [_c('el-tag', {
    attrs: {
      "type": "info",
      "size": "mini"
    }
  }, [_vm._v("请务必填写支付宝账号对应的实名认证真实姓名")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.desc),
      callback: function($$v) {
        _vm.$set(_vm.formData, "desc", $$v)
      },
      expression: "formData.desc"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "divXFTX"
  }, [_c('span', [_vm._v("友情提醒：根据《中华人民共和国宪法》第56条明确规定，依法纳税是每个公民的基本义务。\n                    本平台对作者的收益没有代扣代缴义务，请作者在平台上获得相应的收益后，自行完成纳税义务，\n                    如有疑问，可咨询当地12366纳税服务热线处理，特此告知!\n                ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-tag', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("提现需要收取10%服务费")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1165:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "提现申请",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "金额",
      "prop": "amt"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.amt),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amt", $$v)
      },
      expression: "formData.amt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.desc),
      callback: function($$v) {
        _vm.$set(_vm.formData, "desc", $$v)
      },
      expression: "formData.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款码",
      "prop": "name"
    }
  }, [_c('label', [_vm._v("支付宝/微信收款码上传\n                    "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/gif,image/jpeg,image/jpg,image/png"
    },
    on: {
      "change": function($event) {
        return _vm.changeImg($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "divEWM"
  }, [_vm._v("支付宝优先处理")]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.formData.imgs
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "divXFTX"
  }, [_c('span', [_vm._v("友情提醒：根据《中华人民共和国宪法》第56条明确规定，依法纳税是每个公民的基本义务。\n                    本平台对作者的收益没有代扣代缴义务，请作者在平台上获得相应的收益后，自行完成纳税义务，\n                    如有疑问，可咨询当地12366纳税服务热线处理，特此告知!\n                ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-tag', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("提现需要收取10%服务费")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1166:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "获取二维码",
      "visible": _vm.formVisible,
      "width": "350px"
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-select', {
    staticClass: "sels",
    attrs: {
      "placeholder": "选择方式"
    },
    model: {
      value: (_vm.showmods),
      callback: function($$v) {
        _vm.showmods = $$v
      },
      expression: "showmods"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "网页H5",
      "value": "h5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "微信小程序",
      "value": "xcx"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showmods == 'h5'),
      expression: "showmods == 'h5'"
    }]
  }, [_c('div', {
    staticClass: "qrtits"
  }, [_vm._v("\n        网页通用:\n        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "微信 扫一扫",
      "placement": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/weixinlg.png"
    }
  })]), _vm._v("  \n        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "抖音 扫一扫",
      "placement": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/douyin.png"
    }
  })]), _vm._v("  \n        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "支付宝 扫一扫",
      "placement": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/alipayx.png"
    }
  })]), _vm._v("  \n        "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "今日头条 扫一扫",
      "placement": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/jrtt.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    ref: "qrCodeDiv",
    staticClass: "qrcodeDiv"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showmods == 'xcx'),
      expression: "showmods == 'xcx'"
    }]
  }, [_c('div', {
    staticClass: "qrtits"
  }, [_vm._v("微信小程序")]), _vm._v(" "), _c('div', {
    ref: "qrCodeDivx",
    staticClass: "qrcodeDiv"
  })]), _vm._v(" "), (_vm.showtips == true) ? _c('div', {
    staticClass: "tips"
  }, [_vm._v("温馨提示: 文件二维码有可能会失效, 但是文件夹二维码永远不会失效, 还能随时增减文件噢 !!!")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("完成")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1167:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "修改头像",
      "width": "350px",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.avatimgs
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sels"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/jpg,image/png"
    },
    on: {
      "change": function($event) {
        return _vm.changeImg($event)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1168:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [(!_vm.collapsed) ? _c('a', {
    staticClass: "logoA",
    attrs: {
      "href": "http://jazpan.com"
    }
  }, [_vm._v("夹子盘")]) : _vm._e(), _vm._v(" "), (_vm.collapsed) ? _c('a', {
    staticClass: "logoA",
    attrs: {
      "href": "http://jazpan.com"
    }
  }, [_vm._v("夹")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": _vm.getUserInfo.avat || '//static.jazpan.com/img/user.png'
    }
  }), _vm._v("\n          " + _vm._s(_vm.getUserInfo.nick))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.$refs.passEditor.show()
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logoutFun($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [(!_vm.collapsed) ? _c('div', {
    staticStyle: {
      "height": "100%",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return [(!item.hidden) ? _c('div', {
      key: 'm1:' + index
    }, [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return [(!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()]
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name))]) : _vm._e()], 1) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "prograssDiv"
  }, [_c('div', {
    staticClass: "texts"
  }, [_vm._v(_vm._s(_vm.getFlSize(_vm.spaceInfo.useSize)) + " / " + _vm._s(_vm.spaceInfo.spaceSize) + " GB "), _c('i', {
    staticClass: "el-icon-warning-outline",
    staticStyle: {
      "color": "#f60",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.chongVipDlg.show()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('el-progress', {
    attrs: {
      "show-text": false,
      "percentage": _vm.spaceInfo.percent,
      "status": _vm.spaceInfo.status
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.collapsed) ? _c('ul', {
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return [(!item.hidden) ? _c('li', {
      key: 'm2:' + index,
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_vm._l((item.children), function(child) {
      return [(!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name) + "\n                  ")]) : _vm._e()]
    })], 2)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()]
  })], 2) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)]), _vm._v(" "), _c('PassForm', {
    ref: "passEditor"
  }), _vm._v(" "), _c('ChongVip', {
    ref: "chongVipDlg",
    on: {
      "submitOK": function($event) {
        return _vm.getSpaceInfo()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1169:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainDiv"
  }, [_c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")]), _vm._v(" "), _c('p', {
    staticClass: "page-container"
  }, [_vm._v("网页未找到")]), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/')
      }
    }
  }, [_vm._v("返回首页")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "选择文件",
      "visible": _vm.formVisible,
      "close-on-click-modal": true,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.listQuery
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "搜索"
    },
    model: {
      value: (_vm.listQuery.q),
      callback: function($$v) {
        _vm.$set(_vm.listQuery, "q", $$v)
      },
      expression: "listQuery.q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    model: {
      value: (_vm.listQuery.isme),
      callback: function($$v) {
        _vm.$set(_vm.listQuery, "isme", $$v)
      },
      expression: "listQuery.isme"
    }
  }, [_vm._v("只看自己")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getList()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "dataTable",
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "Loading",
      "border": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.Status < 1) ? _c('span', [_vm._v(_vm._s(row.Name))]) : _c('a', {
          attrs: {
            "href": 'http://jazpan.com/view/' + row.Id,
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "flicon",
          attrs: {
            "src": _vm.$ApiUrl + '/icon?name=' + row.Extion
          }
        }), _vm._v(_vm._s(row.Name) + "\n                        ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "作者",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('a', {
          attrs: {
            "href": 'http://jazpan.com/user/' + row.Uid,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(row.Nick))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticStyle: {
            "color": "#f60",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(row.Amounts))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "大小",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.getFlSize(row.Size)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Timestr))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "disabled": row.InBox
          },
          on: {
            "click": function($event) {
              return _vm.handlerAdd(row)
            }
          }
        }, [_vm._v("添加")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "50px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.pgpage,
      "page-count": _vm.pgpages
    },
    on: {
      "current-change": _vm.getList
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("完成")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1171:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "微信扫码登录",
      "width": "500px",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      },
      "close": _vm.closeFun
    }
  }, [_c('div', [_c('div', {
    staticClass: "wxpaydv"
  }, [_c('div', {
    staticClass: "pay-msg"
  }, [_vm._v("请使用微信扫一扫!")]), _vm._v(" "), _c('div', {
    staticClass: "pay-wars"
  }, [_vm._v("登录过程中请勿刷新页面或关闭浏览器!!!")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loginOk),
      expression: "!loginOk"
    }],
    ref: "wxqrcode",
    staticClass: "wxqrcode"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginOk),
      expression: "loginOk"
    }],
    staticStyle: {
      "line-height": "200px"
    }
  }, [_vm._v("登录成功,正在刷新页面")]), _vm._v(" "), _c('div', {
    staticClass: "wxpayimg"
  }, [_c('img', {
    attrs: {
      "src": "//static.jazpan.com/img/weixinlg.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    on: {
      "click": function($event) {
        return _vm.onWaitFun(false)
      }
    }
  }, [_vm._v("我已扫码完成")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1172:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "搜索"
    },
    model: {
      value: (_vm.filters.q),
      callback: function($$v) {
        _vm.$set(_vm.filters, "q", $$v)
      },
      expression: "filters.q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.editor.show()
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-link', {
    attrs: {
      "type": "primary",
      "href": "https://mp.weixin.qq.com/s/6G-WjS6Na0e1RQhZu7y5aQ",
      "target": "_blank"
    }
  }, [_vm._v("文件夹使用方法")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listdata,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('a', {
          attrs: {
            "href": 'http://jazpan.com/box/' + row.Id,
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "flicon",
          attrs: {
            "src": "//static.jazpan.com/img/flbox.png"
          }
        }), _vm._v("\n          " + _vm._s(row.Name) + "\n        ")]), _vm._v("   "), (row.infoMap.pined == true) ? _c('a', {
          staticStyle: {
            "font-size": "11px",
            "color": "red"
          },
          attrs: {
            "target": "_blank",
            "href": 'http://jazpan.com/user/' + row.Uid
          }
        }, [_vm._v("[置顶]")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Timestr",
      "label": "创建时间",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.$router.push('/file/boxfls?boxid=' + row.Xid)
            }
          }
        }, [_vm._v("管理")]), _vm._v(" "), _c('img', {
          staticClass: "btnQr",
          attrs: {
            "src": "//static.jazpan.com/img/qrcode.png"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.qrcoder.show('https://jazpan.com/box/' + row.Id, 'https://m.jazpan.com/xcx/qrgoto/box?' + row.Id)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "btnQr el-icon-edit-outline",
          staticStyle: {
            "color": "#db3939"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.editor.show(row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "btnQr el-icon-delete",
          staticStyle: {
            "color": "#db3939"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(row)
            }
          }
        }), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": (row.infoMap.pined == true ? '取消置顶' : '置顶') + '在个人主页',
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "btnQr el-icon-top",
          staticStyle: {
            "color": "#db3939"
          },
          on: {
            "click": function($event) {
              return _vm.pinUserFun(row.Xid)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.filters.page,
      "total": _vm.total,
      "page-size": _vm.limit
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "current-change": _vm.getList
    }
  })], 1), _vm._v(" "), _c('FlboxForm', {
    ref: "editor",
    on: {
      "submitOK": _vm.getList
    }
  }), _vm._v(" "), _c('Qrcode', {
    ref: "qrcoder"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1173:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "提现转账信息",
      "visible": _vm.formVisible,
      "close-on-click-modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("方式：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(_vm.infos.fs == 'geren') ? _c('el-tag', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("个人")]) : (_vm.infos.fs == 'qiye') ? _c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("企业")]) : _c('el-tag', [_vm._v("支付宝")])], 1)], 1), _vm._v(" "), (_vm.infos.fs == 'geren') ? _c('div', [_c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.idname))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("身份号：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.idcard))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("银行卡：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.banknum))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("开户行：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.bankaddr))])], 1)], 1) : (_vm.infos.fs == 'qiye') ? _c('div', [_c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("企业名称：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.qyname))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("统一信用码：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.qynum))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("银行帐户：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.banknum))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("开户行：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.bankaddr))])], 1)], 1) : _c('div', [_c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("身份号：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.aliid))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.aliname))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1174:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "搜索"
    },
    model: {
      value: (_vm.filters.q),
      callback: function($$v) {
        _vm.$set(_vm.filters, "q", $$v)
      },
      expression: "filters.q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listdata,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          style: ({
            color: row.Statclr
          })
        }, [_vm._v(_vm._s(row.Stats))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "wxmpTit"
        }, [(row.Isbank > 0) ? _c('el-button', {
          staticStyle: {
            "margin-right": "15px"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.txTaxTips.show(row.Imgs)
            }
          }
        }, [_vm._v("转账信息")]) : _c('img', {
          attrs: {
            "src": row.Imgsrc
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#f60",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(row.Amounts))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Timestr",
      "label": "申请时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Desc",
      "label": "描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Nickup",
      "label": "处理人",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Timeupstr",
      "label": "处理时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button-group', [(row.Stat == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.revokeBackFun(row)
            }
          }
        }, [_vm._v("撤回")]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.filters.page,
      "total": _vm.total,
      "page-size": _vm.limit
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "current-change": _vm.getList
    }
  }), _vm._v(" "), _c('txTaxTips', {
    ref: "txTaxTips"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1175:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "搜索"
    },
    model: {
      value: (_vm.filters.q),
      callback: function($$v) {
        _vm.$set(_vm.filters, "q", $$v)
      },
      expression: "filters.q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listdata,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Title",
      "label": "名称",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticStyle: {
            "color": "#f60"
          }
        }, [_vm._v(_vm._s(row.Amounts))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "余额",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticStyle: {
            "color": "#f60",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(row.Balances))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Timestr",
      "label": "时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "描述"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(row.Desc)
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.Signed) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("正常")]) : _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("账号有误")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.filters.page,
      "total": _vm.total,
      "page-size": _vm.limit
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.filters, "page", $event)
      },
      "current-change": _vm.getList
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1176:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "修改信息",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "排序",
      "prop": "sort"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.sort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sort", $$v)
      },
      expression: "formData.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述",
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.desc),
      callback: function($$v) {
        _vm.$set(_vm.formData, "desc", $$v)
      },
      expression: "formData.desc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1177:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "选择文件夹",
      "visible": _vm.formVisible,
      "close-on-click-modal": true,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.listQuery
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "搜索"
    },
    model: {
      value: (_vm.listQuery.q),
      callback: function($$v) {
        _vm.$set(_vm.listQuery, "q", $$v)
      },
      expression: "listQuery.q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.boxid && _vm.boxid != ''),
      expression: "boxid&&boxid!=''"
    }],
    model: {
      value: (_vm.listQuery.isme),
      callback: function($$v) {
        _vm.$set(_vm.listQuery, "isme", $$v)
      },
      expression: "listQuery.isme"
    }
  }, [_vm._v("只看自己")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getList()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "Loading",
      "border": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('a', {
          attrs: {
            "href": 'http://jazpan.com/box/' + row.Id,
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "flicon",
          attrs: {
            "src": "//static.jazpan.com/img/flbox.png"
          }
        }), _vm._v(_vm._s(row.Name) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "作者",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('a', {
          attrs: {
            "href": 'http://jazpan.com/user/' + row.Uid,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(row.infoMap.nick))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "浏览",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Views))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Timestr))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "disabled": row.infoMap.inBox
          },
          on: {
            "click": function($event) {
              return _vm.handlerAdd(row)
            }
          }
        }, [_vm._v("添加\n              ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "50px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "current-page": _vm.pgpage,
      "page-count": _vm.pgpages
    },
    on: {
      "current-change": _vm.getList
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("完成")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getToken = exports.getToken = function getToken() {
    return sessionStorage.getItem('token');
};
var setToken = exports.setToken = function setToken(tks) {
    sessionStorage.setItem('token', tks);
};
var removeToken = exports.removeToken = function removeToken() {
    sessionStorage.removeItem('token');
};

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1086)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(1150),
  /* scopeId */
  "data-v-12bf76a3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1102)
__webpack_require__(1103)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1166),
  /* scopeId */
  "data-v-4aefa200",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(208);

var _axios2 = _interopRequireDefault(_axios);

var _storage = __webpack_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var apiUrl = '//mgrsc.jazpan.com';

var serv = _axios2.default.create({
    baseURL: apiUrl,
    withCredentials: true
});

var post = function post(path, params, headers) {
    var hds = {};
    if (headers) hds = headers;
    var token = (0, _storage.getToken)();
    if (token) hds['Authorization'] = 'TOKEN ' + token;
    return serv.post(path, params, { headers: hds });
};

exports.default = {
    post: post, apiUrl: apiUrl
};

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(34);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(131);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(536);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(537);

var getters = _interopRequireWildcard(_getters);

var _mutations = __webpack_require__(538);

var mutations = _interopRequireWildcard(_mutations);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    userinfo: {}
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1115)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1177),
  /* scopeId */
  "data-v-f37c7836",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1097)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(1161),
  /* scopeId */
  "data-v-2fbbca98",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1092)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1156),
  /* scopeId */
  "data-v-24e307f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1088)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1152),
  /* scopeId */
  "data-v-1ab540c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1111)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1173),
  /* scopeId */
  "data-v-68d8ab8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mock = __webpack_require__(535);

var _mock2 = _interopRequireDefault(_mock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _mock2.default;

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(34);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(1178);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(297);

var _store2 = _interopRequireDefault(_store);

var _Home = __webpack_require__(1131);

var _Home2 = _interopRequireDefault(_Home);

var _ = __webpack_require__(1130);

var _2 = _interopRequireDefault(_);

var _storage = __webpack_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: __webpack_require__(1132),
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/',
    hidden: true,
    redirect: { path: '/main' }
}, {
    path: '/',
    component: _Home2.default,
    name: '用户中心',
    iconCls: 'el-icon-user',
    children: [{ path: '/main', component: __webpack_require__(1133), name: '用户信息' }, { path: '/bills', component: __webpack_require__(1141), name: '账单记录' }, { path: '/txs', component: __webpack_require__(1145), name: '提现记录', hidden: true }]
}, {
    path: '/',
    component: _Home2.default,
    name: '资源中心',
    iconCls: 'el-icon-suitcase',
    children: [{ path: '/file/boxs', component: __webpack_require__(1140), name: '文件夹' }, { path: '/file/fls', component: __webpack_require__(1137), name: '文件管理' }, { path: '/file/boxfls', component: __webpack_require__(1135), name: '文件夹管理', hidden: true }, { path: '/file/orders', component: __webpack_require__(1143), name: '下载记录' }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

_vue2.default.use(_vueRouter2.default);
var router = new _vueRouter2.default({ routes: routes });

router.beforeEach(function (to, from, next) {
    if (to.path == '/login') {
        (0, _storage.removeToken)();
        next();
        return;
    }
    if (to.path == '/404') {
        next();
        return;
    }

    _store2.default.dispatch('getLgInfo').then(function () {
        if (_store2.default.state.userinfo.login == true) {
            next();
        } else {
            next('/login?redirect=' + to.path);
        }
    }).catch(function (err) {
        console.log('getLgInfo err:', err);
        next('/login?redirect=' + to.path);
    });
});

exports.default = router;

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1093)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      formVisible: false,
      formLoading: false,
      submiting: false
    };
  },

  methods: {
    close: function close() {
      if (this.formVisible == true) this.formVisible = false;
    },
    show: function show() {
      this.formVisible = true;
    },
    closeFun: function closeFun(e) {
      this.$emit('close');
    },
    chongVipFun: function chongVipFun(lev, mon) {
      var _this = this;

      if (this.submiting) return;
      this.$confirm('确定充值吗?', '提示', {
        type: 'warning'
      }).then(function () {
        _this.submiting = true;
        _this.$post('/user/vip', { lev: lev, mon: mon }).then(function (res) {
          _this.$emit('submitOK');
          _this.submiting = false;
          _this.formLoading = true;
          _this.formVisible = false;
          _this.$message({
            message: '充值成功!!',
            type: 'success'
          });
        }).catch(function (err) {
          _this.submiting = false;
          _this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    }
  }
};

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(89);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(131);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      formVisible: false,
      formLoading: false,
      submiting: false,
      activeName: 'wxpay',
      amtsVal: ''
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUserInfo'])),
  methods: {
    close: function close() {
      if (this.formVisible == true) this.formVisible = false;
    },
    show: function show() {
      this.formVisible = true;
      this.submiting = false;
      this.activeName = 'wxpay';
      this.amtsVal = '';
    },
    closeFun: function closeFun(e) {
      this.$emit('close');
    },
    chongZhiFun: function chongZhiFun() {
      if (this.submiting) return;
      this.submiting = true;
      this.showQrcode();
    },
    showQrcode: function showQrcode() {
      this.$refs.qrcodeDiv.innerHTML = '';
      var url = "http:" + this.$ApiUrl + "/user/pays/gopay/" + this.getUserInfo.uid + "?amts=" + this.amtsVal;
      new QRCode(this.$refs.qrcodeDiv, {
        text: url,
        width: 150,
        height: 150
      });
    },
    checkFun: function checkFun() {
      window.location.reload();
    }
  }
};

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      formVisible: false,
      formLoading: false,
      vwid: '',
      loginOk: false
    };
  },

  methods: {
    genUUID: function genUUID() {
      function S4() {
        return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
      }
      return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
    },
    close: function close() {
      if (this.formVisible == true) this.formVisible = false;
    },
    show: function show() {
      this.formVisible = true;

      this.vwid = this.genUUID();
      setTimeout(this.showQrcode, 100);
    },
    showQrcode: function showQrcode() {
      this.$refs.wxqrcode.innerHTML = '';
      var url = 'http:' + this.$ApiUrl + "/lg/wx/goto?vwid=" + this.vwid;
      new QRCode(this.$refs.wxqrcode, {
        text: url,
        width: 200,
        height: 200
      });
      this.onWaitFun(true);
    },
    closeFun: function closeFun(e) {
      this.$emit('close');
    },
    onWaitFun: function onWaitFun(cf) {
      var _this = this;

      this.$post('/lg/wx/wait', { vwid: this.vwid }).then(function (res) {
        _this.$emit('submitOK');
        _this.loginOk = true;
        _this.formLoading = true;
      }).catch(function (err) {
        if (cf && _this.formVisible) setTimeout(function () {
          _this.onWaitFun(cf);
        }, 100);
      });
    }
  }
};

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(89);

var _extends3 = _interopRequireDefault(_extends2);

var _util = __webpack_require__(88);

var _util2 = _interopRequireDefault(_util);

var _vuex = __webpack_require__(131);

var _PassForm = __webpack_require__(1144);

var _PassForm2 = _interopRequireDefault(_PassForm);

var _ChongVip = __webpack_require__(287);

var _ChongVip2 = _interopRequireDefault(_ChongVip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { PassForm: _PassForm2.default, ChongVip: _ChongVip2.default },
  data: function data() {
    return {
      collapsed: false,
      spaceInfo: {},
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUserInfo'])),
  methods: {
    getFlSize: _util2.default.getFlSize,
    onSubmit: function onSubmit() {
      console.log('submit!');
    },
    handleopen: function handleopen() {},
    handleclose: function handleclose() {},

    handleselect: function handleselect(a, b) {},

    logoutFun: function logoutFun() {
      var _this = this;

      var that = this;
      this.$confirm('确认退出吗?', '提示', {}).then(function () {
        _this.$post('/lg/logout').then(function (res) {
          _this.$message('退出成功');

          _this.$router.push('/login');
        }).catch(function (err) {
          _this.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      }).catch(function () {});
    },

    collapse: function collapse() {
      this.collapsed = !this.collapsed;
    },
    showMenu: function showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
    },
    getSpaceInfo: function getSpaceInfo() {
      var _this2 = this;

      this.$post('/user/space/info', {}).then(function (res) {
        _this2.spaceInfo = res.data;
      }).catch(function (err) {
        _this2.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    }
  },
  mounted: function mounted() {
    var user = sessionStorage.getItem('user');
    if (user) {
      user = JSON.parse(user);
      this.sysUserName = user.name || '';
      this.sysUserAvatar = user.avatar || '';
    }

    this.getSpaceInfo();
  }
};

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WxLoginDlg = __webpack_require__(1129);

var _WxLoginDlg2 = _interopRequireDefault(_WxLoginDlg);

var _storage = __webpack_require__(209);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { WxLoginDlg: _WxLoginDlg2.default },
  data: function data() {
    return {
      redirect: null,
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: '',
        remember: false
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },
  mounted: function mounted() {
    this.redirect = this.$route.query.redirect;
  },

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this2.logining = true;

          var loginParams = { name: _this2.ruleForm2.account, pass: _this2.ruleForm2.checkPass, remember: _this2.ruleForm2.remember };
          _this2.$post('/lg/login', loginParams).then(function (res) {
            _this2.logining = false;

            if (false) (0, _storage.setToken)(res.data);
            console.log('redirect:', _this2.redirect);
            _this2.$router.push(_this2.redirect || '/');
          }).catch(function (err) {
            _this2.logining = false;
            _this2.$message({
              message: err.response ? err.response.data || '服务器错误' : '网络错误',
              type: 'error'
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(89);

var _extends3 = _interopRequireDefault(_extends2);

var _echarts = __webpack_require__(783);

var echarts = _interopRequireWildcard(_echarts);

var _NameForm = __webpack_require__(1142);

var _NameForm2 = _interopRequireDefault(_NameForm);

var _proEdit = __webpack_require__(433);

var _proEdit2 = _interopRequireDefault(_proEdit);

var _avatEdit = __webpack_require__(1146);

var _avatEdit2 = _interopRequireDefault(_avatEdit);

var _txEdit = __webpack_require__(1147);

var _txEdit2 = _interopRequireDefault(_txEdit);

var _txTaxEdit = __webpack_require__(1148);

var _txTaxEdit2 = _interopRequireDefault(_txTaxEdit);

var _ChongVip = __webpack_require__(287);

var _ChongVip2 = _interopRequireDefault(_ChongVip);

var _ChongZhi = __webpack_require__(1128);

var _ChongZhi2 = _interopRequireDefault(_ChongZhi);

var _vuex = __webpack_require__(131);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { NameForm: _NameForm2.default, proEdit: _proEdit2.default, avatEdit: _avatEdit2.default, txEdit: _txEdit2.default, txTaxEdit: _txTaxEdit2.default, ChongVip: _ChongVip2.default, ChongZhi: _ChongZhi2.default },
  data: function data() {
    return {
      balances: '0.0',
      balancetx: '0.0',
      blChart1: null,
      blChart2: null,
      showTxRank: true,
      txRanks: []
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUserInfo'])),
  mounted: function mounted() {
    this.balances = this.getUserInfo.balances;
    this.getBalances();
  },

  methods: {
    refreshPg: function refreshPg() {
      window.top.location.reload();
    },
    getBalances: function getBalances() {
      var _this = this;

      this.$post('/user/balance').then(function (res) {
        _this.balances = res.data.balances;
        _this.balancetx = res.data.balancetx;
        _this.drawBlChart1();
        _this.drawBlChart2();
      }).catch(function (err) {
        _this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    tixianFun: function tixianFun() {
      if (this.getUserInfo.txstat > 0) this.$refs.txTaxEdit.show();else this.$refs.txEdit.show();
    },
    getTxRank: function getTxRank() {
      var _this2 = this;

      this.$post('/user/txsrank', { limit: 20 }).then(function (res) {
        _this2.txRanks = res.data;
      }).catch(function (err) {
        _this2.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    drawBlChart1: function drawBlChart1() {
      var _this3 = this;

      this.blChart1 = echarts.init(document.getElementById('blChart1'));
      this.$post('/user/balances/1').then(function (res) {
        console.log('balances data:', res.data);
        _this3.blChart1.setOption({
          title: {
            text: '收入详情（单位：元）',
            textStyle: { color: '#f60' }
          },
          tooltip: {},
          xAxis: {
            data: ["今日", "昨日", "前7日", "本月", "上个月", "今年"]
          },
          yAxis: {},
          series: [{
            name: '元',
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            itemStyle: {
              normal: {
                color: '#f60'
              }
            },
            data: res.data
          }]
        });
      });
    },
    drawBlChart2: function drawBlChart2() {
      var _this4 = this;

      this.blChart2 = echarts.init(document.getElementById('blChart2'));
      this.$post('/user/balances/2').then(function (res) {
        console.log('balances data:', res.data);
        _this4.blChart2.setOption({
          title: {
            text: '支出详情（单位：元）',
            textStyle: { color: '#5470c6' }
          },
          tooltip: {},
          xAxis: {
            data: ["今日", "昨日", "前7日", "本月", "上个月", "今年"]
          },
          yAxis: {},
          series: [{
            name: '元',
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            data: res.data
          }]
        });
      });
    }
  }
};

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      formVisible: false,
      formLoading: false,
      formRules: {
        tmpltid: [{ required: true, message: '请选择模版' }], title: [{ required: true, message: '请输入任务名称' }], name: [{ required: true, message: '请输入短信名称' }], phone: [{ required: true, message: '请输入参数' }], level: [{ required: true, message: '请输入参数' }]
      },

      formData: {}
    };
  },

  methods: {
    show: function show(et) {
      if (!et || et == null) return;
      this.formVisible = true;
      this.formData = {
        xid: et.Xid,
        boxid: et.Boxid,
        sort: et.Sort || '',
        desc: et.Desc || ''
      };
    },
    formSubmit: function formSubmit() {
      var _this = this;

      this.$refs.formd.validate(function (valid) {
        if (valid) {
          _this.formLoading = true;
          _this.$post('/user/boxinfoup', _this.formData).then(function (res) {
            console.log(res);
            _this.$emit('submitOK');
            _this.formLoading = false;
            _this.formVisible = false;
          }).catch(function (err) {
            _this.$emit('submitErr', err);
            _this.formLoading = false;

            _this.$message({
              message: err.response ? err.response.data || '服务器错误' : '网络错误',
              type: 'error'
            });
          });
        }
      });
    }
  }
};

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(88);

var _util2 = _interopRequireDefault(_util);

var _FileEdit = __webpack_require__(431);

var _FileEdit2 = _interopRequireDefault(_FileEdit);

var _BoxFileForm = __webpack_require__(1134);

var _BoxFileForm2 = _interopRequireDefault(_BoxFileForm);

var _BoxSelfForm = __webpack_require__(1136);

var _BoxSelfForm2 = _interopRequireDefault(_BoxSelfForm);

var _FileSelForm = __webpack_require__(1138);

var _FileSelForm2 = _interopRequireDefault(_FileSelForm);

var _BoxSelForm = __webpack_require__(430);

var _BoxSelForm2 = _interopRequireDefault(_BoxSelForm);

var _Qrcode = __webpack_require__(288);

var _Qrcode2 = _interopRequireDefault(_Qrcode);

var _Upload = __webpack_require__(432);

var _Upload2 = _interopRequireDefault(_Upload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { FileEdit: _FileEdit2.default, BoxFileForm: _BoxFileForm2.default, BoxSelfForm: _BoxSelfForm2.default, FileSelForm: _FileSelForm2.default, BoxSelForm: _BoxSelForm2.default, Qrcode: _Qrcode2.default, Upload: _Upload2.default },
  data: function data() {
    return {
      boxid: '',
      box: null,
      upShow: true,
      upShowRW: 'auto',
      listLoading: false,
      listQuery: {
        q: ''
      },
      tableData: [],
      boxlistData: [],
      boxlistLoading: false
    };
  },
  mounted: function mounted() {
    this.inits();
  },
  methods: {
    getFlSize: _util2.default.getFlSize,
    inits: function inits(bid) {
      this.boxid = this.$route.query.boxid;
      if (bid) {
        this.$router.push('/file/boxfls?boxid=' + bid);
        this.boxid = bid;
      }
      if (this.boxid == null || this.boxid == '') {
        this.clearBox();
        return;
      }
      this.getBox();
      this.getList();
      this.getBoxList();
      this.upShowRW = this.$refs.rightDiv.clientWidth + 'px';
    },
    clearBox: function clearBox() {
      this.$router.push('/file/fls');
    },
    getBox: function getBox() {
      var _this = this;

      this.$post('/user/box', { xid: this.boxid }).then(function (res) {
        _this.box = res.data;
      }).catch(function (err) {
        _this.clearBox();
      });
    },
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;
      this.listQuery.boxid = this.boxid;
      this.$post('/user/boxfls', this.listQuery).then(function (res) {
        console.log('fls:', res);
        _this2.listLoading = false;
        _this2.tableData = res.data;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    getBoxList: function getBoxList() {
      var _this3 = this;

      this.boxlistLoading = true;
      this.listQuery.boxid = this.boxid;
      this.$post('/user/boxselfs', this.listQuery).then(function (res) {
        _this3.boxlistLoading = false;
        _this3.boxlistData = res.data;
      }).catch(function (err) {
        _this3.boxlistLoading = false;
        _this3.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    onKeySortFun: function onKeySortFun() {
      var _this4 = this;

      this.$confirm('确定要按文件名排序所有文件吗? (最好开头有数字，不包括文件夹)', '提示', {
        type: 'warning'
      }).then(function () {
        _this4.$post('/user/box/flsorts', { boxid: _this4.boxid }).then(function (res) {
          _this4.$message('排序成功');
          _this4.getList();
        }).catch(function (err) {
          _this4.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    },
    delFun: function delFun(xid) {
      var _this5 = this;

      this.$confirm('确定要永久删除此文件吗?', '提示', {
        type: 'warning'
      }).then(function () {
        _this5.$post('/user/fldel', { xid: xid }).then(function (res) {
          _this5.$message('删除成功');
          _this5.getList();
        }).catch(function (err) {
          _this5.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    },
    rmFun: function rmFun(bid, xid) {
      var _this6 = this;

      this.$confirm('确定要把文件从文件夹移除吗?\n只是移除该文件夹(不会删除)', '提示', {
        type: 'warning'
      }).then(function () {
        _this6.$post('/user/boxinform', { boxid: bid, xid: xid }).then(function (res) {
          _this6.$message('移除成功');
          _this6.getList();
        }).catch(function (err) {
          _this6.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    },
    rmBoxFun: function rmBoxFun(bid, xid) {
      var _this7 = this;

      this.$confirm('确定要把文件夹从文件夹移除吗?\n只是移除该文件夹(不会删除)', '提示', {
        type: 'warning'
      }).then(function () {
        _this7.$post('/user/boxinforms', { boxid: bid, xid: xid }).then(function (res) {
          _this7.$message('移除成功');
          _this7.getBoxList();
        }).catch(function (err) {
          _this7.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    },
    handleHide: function handleHide() {
      this.upShow = !this.upShow;
      this.$refs.dataTable.doLayout();
      this.$refs.boxdataTable.doLayout();
    },
    changeSortFun: function changeSortFun(e) {
      console.log('changeSortFun:', e);
      if (e.order) {
        this.listQuery.sort = {};
        this.listQuery.sort[e.prop] = e.order == "ascending" ? 1 : 2;
      } else {
        this.listQuery.sort = null;
      }
      this.getList();
    }
  }
};

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(88);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      boxid: '',
      fileid: '',
      formVisible: false,
      formLoading: false,
      listLoading: false,
      pgpage: 1,
      pgpages: 1,
      listQuery: {},
      tableData: []
    };
  },
  mounted: function mounted() {},

  methods: {
    show: function show(bid, fid) {
      if (bid) this.boxid = bid;else if (fid) this.fileid = fid;else return;
      this.pgpage = 1;
      this.pgpages = 1;
      this.listQuery = {
        q: '',
        isme: true,
        page: 1
      };
      this.formVisible = true;
      this.getList();
    },

    getFlSize: _util2.default.getFlSize,
    getList: function getList(pg) {
      var _this = this;

      this.listLoading = true;
      var pars = this.listQuery;
      pars.boxid = this.boxid;
      pars.page = pg || this.pgpage;
      this.$post('/user/box/page', pars).then(function (res) {
        _this.listLoading = false;
        _this.pgpage = res.data.Page;
        _this.pgpages = res.data.Pages;
        _this.tableData = res.data.Data;
      }).catch(function (err) {
        _this.listLoading = false;
        _this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    handlerAdd: function handlerAdd(et) {
      if (this.boxid && this.boxid != '') this.handlerAddBox(et);
      if (this.fileid && this.fileid != '') this.handlerAddFile(et);
    },
    handlerAddBox: function handlerAddBox(et) {
      var _this2 = this;

      this.$post('/user/boxinfoups', { boxid: this.boxid, xid: et.Xid, sort: 10, isadd: true }).then(function (res) {
        et.infoMap.inBox = true;
        _this2.$message('添加成功');
        _this2.$emit('submitOK');
        _this2.$forceUpdate();
      }).catch(function (err) {
        _this2.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    handlerAddFile: function handlerAddFile(et) {
      var _this3 = this;

      this.$post('/user/boxinfoup', { boxid: et.Xid, xid: this.fileid, sort: 10, isadd: true }).then(function (res) {
        et.infoMap.inBox = true;
        _this3.$message('添加成功');
        _this3.$emit('submitOK');
        _this3.$forceUpdate();
      }).catch(function (err) {
        _this3.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    }
  }
};

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      formVisible: false,
      formLoading: false,
      formRules: {
        tmpltid: [{ required: true, message: '请选择模版' }], title: [{ required: true, message: '请输入任务名称' }], name: [{ required: true, message: '请输入短信名称' }], phone: [{ required: true, message: '请输入参数' }], level: [{ required: true, message: '请输入参数' }]
      },

      formData: {}
    };
  },

  methods: {
    show: function show(et) {
      if (!et || et == null) return;
      this.formVisible = true;
      this.formData = {
        xid: et.Xid,
        boxid: et.Prtid,
        sort: et.Sort || '',
        desc: et.Desc || ''
      };
    },
    formSubmit: function formSubmit() {
      var _this = this;

      this.$refs.formd.validate(function (valid) {
        if (valid) {
          _this.formLoading = true;
          _this.$post('/user/boxinfoups', _this.formData).then(function (res) {
            console.log(res);
            _this.$emit('submitOK');
            _this.formLoading = false;
            _this.formVisible = false;
          }).catch(function (err) {
            _this.$emit('submitErr', err);
            _this.formLoading = false;

            _this.$message({
              message: err.response ? err.response.data || '服务器错误' : '网络错误',
              type: 'error'
            });
          });
        }
      });
    }
  }
};

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var regAmt = /^\d+(\.\d+)?$/;
var regFlnmfhs = /[`'"\\/:*?<>|]/;
exports.default = {
  data: function data() {
    return {
      fenleis: [],
      formVisible: false,
      formLoading: false,
      formRules: {
        name: [{ required: true, message: '请输入参数' }, {
          validator: function validator(rule, v, fn) {
            if (v != '' && regFlnmfhs.test(v)) {
              fn(new Error('格式错误：不能有特殊符号 `\'"\\/:*?等'));
              return;
            }
            fn();
          }
        }], fenlei: [{ required: true, message: '请输入参数' }], amount: [{ required: true, message: '请输入参数' }, {
          validator: function validator(rule, value, callback) {
            if (value == '') callback(new Error('请输入金额!'));else if (regAmt.test(value)) {
              callback();
            } else callback(new Error('格式错误：必须是 "数字"'));
          }
        }]
      },

      formData: {}
    };
  },
  mounted: function mounted() {
    this.getFenleis();
  },

  methods: {
    show: function show(it) {
      this.formVisible = true;
      this.formData = {
        xid: it ? it.Xid : '',
        name: it.Name,
        amount: it.Amounts,
        descpt: it.Descpt,
        fenlei: it.Fl1pro,

        jm: it.Jm == 1,
        pass: it.Pass
      };
    },
    formSubmit: function formSubmit() {
      var _this = this;

      this.$refs.formd.validate(function (valid) {
        if (valid) {
          if (_this.formData.jm && _this.formData.pass == '') {
            _this.$message({
              message: '未填写密码',
              type: 'error'
            });
            return;
          }
          _this.formLoading = true;
          _this.$post('/user/fledit', _this.formData).then(function (res) {
            console.log(res);
            _this.$emit('submitOK');
            _this.formLoading = false;
            _this.formVisible = false;
          }).catch(function (err) {
            _this.$emit('submitErr', err);
            _this.formLoading = false;

            _this.$message({
              message: err.response ? err.response.data || '服务器错误' : '网络错误',
              type: 'error'
            });
          });
        }
      });
    },
    getFenleis: function getFenleis() {
      var _this2 = this;

      this.$post('/comm/fls/pro').then(function (res) {
        console.log('getFenleis:', res);
        _this2.fenleis = res.data;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    }
  }
};

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(88);

var _util2 = _interopRequireDefault(_util);

var _FileEdit = __webpack_require__(431);

var _FileEdit2 = _interopRequireDefault(_FileEdit);

var _BoxSelForm = __webpack_require__(430);

var _BoxSelForm2 = _interopRequireDefault(_BoxSelForm);

var _Qrcode = __webpack_require__(288);

var _Qrcode2 = _interopRequireDefault(_Qrcode);

var _Upload = __webpack_require__(432);

var _Upload2 = _interopRequireDefault(_Upload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { FileEdit: _FileEdit2.default, BoxSelForm: _BoxSelForm2.default, Qrcode: _Qrcode2.default, Upload: _Upload2.default },
  data: function data() {
    return {
      upShow: true,
      upShowRW: 'auto',
      listLoading: false,
      pgpage: 1,
      pgpages: 1,
      listQuery: {
        q: '',
        page: 1
      },
      tableData: []
    };
  },
  mounted: function mounted() {
    this.getList();
    this.upShowRW = this.$refs.rightDiv.clientWidth + 'px';
  },
  methods: {
    getFlSize: _util2.default.getFlSize,
    getList: function getList(pg) {
      var _this = this;

      this.listLoading = true;
      this.listQuery.page = pg || this.pgpage;
      this.$post('/user/fls', this.listQuery).then(function (res) {
        console.log('fls:', res);
        _this.listLoading = false;
        _this.pgpage = res.data.Page;
        _this.pgpages = res.data.Pages;
        _this.tableData = res.data.Data;
      }).catch(function (err) {
        _this.listLoading = false;
        _this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    delFun: function delFun(xid) {
      var _this2 = this;

      this.$confirm('确定要永久删除此文件吗?', '提示', {
        type: 'warning'
      }).then(function () {
        _this2.$post('/user/fldel', { xid: xid }).then(function (res) {
          _this2.$message('删除成功');
          _this2.getList();
        }).catch(function (err) {
          _this2.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    },
    pinUserFun: function pinUserFun(xid) {
      var _this3 = this;

      this.$confirm('确定置顶该文件吗? (置顶后可以到个人主页查看)', '提示', {
        type: 'warning'
      }).then(function () {
        _this3.$post('/user/flpin', { typ: 1, xid: xid }).then(function (res) {
          _this3.$message('操作成功');
          _this3.getList();
        }).catch(function (err) {
          _this3.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    },
    handleHide: function handleHide() {
      this.upShow = !this.upShow;
      this.$refs.dataTable.doLayout();
    },
    changeSortFun: function changeSortFun(e) {
      console.log('changeSortFun:', e);
      if (e.order) {
        this.listQuery.sort = {};
        this.listQuery.sort[e.prop] = e.order == "ascending" ? 1 : 2;
      } else {
        this.listQuery.sort = null;
      }
      this.getList();
    }
  }
};

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(88);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            boxid: '',
            formVisible: false,
            formLoading: false,
            listLoading: false,
            pgpage: 1,
            pgpages: 1,
            listQuery: {},
            tableData: []
        };
    },
    mounted: function mounted() {},

    methods: {
        show: function show(bid) {
            if (!bid || bid == '') return;
            this.boxid = bid;
            this.pgpage = 1;
            this.pgpages = 1;
            this.listQuery = {
                q: '',
                isme: true,
                page: 1
            };
            this.formVisible = true;
            this.getList();
        },

        getFlSize: _util2.default.getFlSize,
        getList: function getList(pg) {
            var _this = this;

            this.listLoading = true;
            var pars = this.listQuery;
            pars.boxid = this.boxid;
            pars.page = pg || this.pgpage;
            this.$post('/user/fl/page', pars).then(function (res) {
                console.log('fls:', res);
                _this.listLoading = false;
                _this.pgpage = res.data.Page;
                _this.pgpages = res.data.Pages;
                _this.tableData = res.data.Data;
            }).catch(function (err) {
                _this.listLoading = false;
                _this.$message({
                    message: err.response ? err.response.data || '服务器错误' : '网络错误',
                    type: 'error'
                });
            });
        },
        handlerAdd: function handlerAdd(et) {
            var _this2 = this;

            this.$post('/user/boxinfoup', { boxid: this.boxid, xid: et.Xid, sort: 10, isadd: true }).then(function (res) {
                et.InBox = true;
                _this2.$message('添加成功');
                _this2.$emit('submitOK');
            }).catch(function (err) {
                _this2.$message({
                    message: err.response ? err.response.data || '服务器错误' : '网络错误',
                    type: 'error'
                });
            });
        }
    }
};

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            fenleis: [],
            formVisible: false,
            formLoading: false,
            formRules: {
                name: [{ required: true, message: '请输入参数' }], fenlei: [{ required: true, message: '请输入参数' }], desc: [{ required: true, message: '请输入参数' }]
            },

            formData: {}
        };
    },
    mounted: function mounted() {
        this.getFenleis();
    },

    methods: {
        show: function show(e) {
            this.formVisible = true;
            this.formData = {
                name: '',
                desc: '',
                fenlei: '1'
            };
            if (e) {
                this.formData.xid = e.Xid;
                this.formData.name = e.Name;
                this.formData.desc = e.Desc;
                this.formData.fenlei = e.Fl1pro;
            }
        },
        formSubmit: function formSubmit() {
            var _this = this;

            this.$refs.formd.validate(function (valid) {
                if (valid) {
                    _this.formLoading = true;
                    _this.$post('/user/boxedit', _this.formData).then(function (res) {
                        console.log(res);
                        _this.$emit('submitOK');
                        _this.formLoading = false;
                        _this.formVisible = false;
                    }).catch(function (err) {
                        _this.$emit('submitErr', err);
                        _this.formLoading = false;

                        _this.$message({
                            message: err.response ? err.response.data || '服务器错误' : '网络错误',
                            type: 'error'
                        });
                    });
                }
            });
        },
        getFenleis: function getFenleis() {
            var _this2 = this;

            this.$post('/comm/fls/pro').then(function (res) {
                console.log('getFenleis:', res);
                _this2.fenleis = res.data;
            }).catch(function (err) {
                _this2.listLoading = false;
                _this2.$message({
                    message: err.response ? err.response.data || '服务器错误' : '网络错误',
                    type: 'error'
                });
            });
        }
    }
};

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(88);

var _util2 = _interopRequireDefault(_util);

var _FlboxForm = __webpack_require__(1139);

var _FlboxForm2 = _interopRequireDefault(_FlboxForm);

var _Qrcode = __webpack_require__(288);

var _Qrcode2 = _interopRequireDefault(_Qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { FlboxForm: _FlboxForm2.default, Qrcode: _Qrcode2.default },
  data: function data() {
    return {
      filters: {
        page: 1,
        s: '',
        q: ''
      },
      loading: false,
      total: 0,
      limit: 0,
      listdata: [],
      sels: [] };
  },
  mounted: function mounted() {
    this.getList();
  },

  methods: {
    getList: function getList() {
      var _this = this;

      this.loading = true;

      this.$post('/user/boxs', this.filters).then(function (res) {
        console.log(res);
        _this.loading = false;
        _this.listdata = res.data.Data;
        _this.total = res.data.Total;
        _this.limit = res.data.Size;
        _this.filters.page = res.data.Page;
      }).catch(function (err) {
        _this.$message({
          message: err.response.data || '服务器错误',
          type: 'error'
        });
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleAdd: function handleAdd() {},
    handleEdit: function handleEdit() {},
    handleDel: function handleDel(et) {
      var _this2 = this;

      this.$confirm('确定要删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        _this2.$post('/user/boxdel', { xid: et.Xid }).then(function (res) {
          _this2.getList();
        }).catch(function (err) {
          _this2.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    },
    batchRemove: function batchRemove() {},
    pinUserFun: function pinUserFun(xid) {
      var _this3 = this;

      this.$confirm('确定置顶该文件夹吗? (置顶后可以到个人主页查看)', '提示', {
        type: 'warning'
      }).then(function () {
        _this3.$post('/user/flpin', { typ: 0, xid: xid }).then(function (res) {
          _this3.$message('操作成功');
          _this3.getList();
        }).catch(function (err) {
          _this3.$message({
            message: err.response ? err.response.data || '服务器错误' : '网络错误',
            type: 'error'
          });
        });
      });
    }
  }
};

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["showtips"],
  data: function data() {
    return {
      formVisible: false,
      shuiying: false,
      conts: '',
      conts2: '',
      showmods: 'h5'
    };
  },

  methods: {
    show: function show(cont1, cont2) {
      if (!cont1 || cont1 == '') return;
      this.formVisible = true;
      this.shuiying = false;
      this.conts = cont1;
      this.conts2 = cont2;
      this.upQrCode();
    },
    upQrCode: function upQrCode() {
      var _this = this;

      if (!this.$refs.qrCodeDiv) {
        setTimeout(function () {
          _this.upQrCode();
        }, 100);
        return;
      }
      var mrgs = (this.shuiying ? 100 : 50) + 'px';
      console.log('---shuiying:', this.shuiying, mrgs);
      this.$refs.qrCodeDiv.innerHTML = '';
      this.$refs.qrCodeDivx.innerHTML = '';
      new QRCode(this.$refs.qrCodeDiv, {
        text: this.conts,
        width: 200,
        height: 200,
        margin: mrgs
      });
      new QRCode(this.$refs.qrCodeDivx, {
        text: this.conts2,
        width: 200,
        height: 200,
        margin: mrgs
      });
    },
    syChange: function syChange() {
      this.upQrCode();
    }
  }
};

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(210);

var _promise2 = _interopRequireDefault(_promise);

var _ChongVip = __webpack_require__(287);

var _ChongVip2 = _interopRequireDefault(_ChongVip);

var _proEdit = __webpack_require__(433);

var _proEdit2 = _interopRequireDefault(_proEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { ChongVip: _ChongVip2.default, proEdit: _proEdit2.default },
  data: function data() {
    return {
      boxids: '',
      amount: '',
      fenlei: '',
      fenleis: [],
      upTokenData: null,

      uploadActUrl: '',

      submiting: false
    };
  },
  props: ['boxid'], watch: {
    boxid: function boxid(val) {
      console.log('upload boxid update:', val);
      this.boxids = val || '';
    }
  }, mounted: function mounted() {
    console.log('upload boxid:', this.boxids);
    this.getFenleis();
  },
  methods: {
    refreshPg: function refreshPg() {
      window.top.location.reload();
    },
    getFenleis: function getFenleis() {
      var _this = this;

      this.$post('/comm/fls/pro').then(function (res) {
        console.log('getFenleis:', res);
        _this.fenleis = res.data;
      }).catch(function (err) {
        _this.listLoading = false;
        _this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    upSubmit: function upSubmit() {
      var _this2 = this;

      if (this.fenlei == '') {
        this.$message({
          message: '请先选择分类',
          type: 'error'
        });
        return;
      }

      if (this.submiting) return;
      var istls = false;
      if (window && window.location) {
        var ul = window.location.toString();
        istls = ul.startsWith('https:');
      }
      this.$post('/up/token', { tls: istls }).then(function (res) {
        _this2.upTokenData = res.data;
        _this2.submiting = true;
        _this2.$refs.upload.submit();
      }).catch(function (err) {
        _this2.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
        if (err.response.status == 511) {
          setTimeout(function () {
            return _this2.$refs.chongVipDlg.show();
          }, 1000);
        }
        if (err.response.status == 512) {
          setTimeout(function () {
            return _this2.$refs.proEdit.show();
          }, 1000);
        }
      });
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      var _this3 = this;

      var flsz = file.size;
      console.log('file [' + file.name + '] size:' + flsz);
      if (flsz < 100) {
        this.$message({
          message: '【' + (file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name) + '】 文件太小了',
          type: 'error'
        });
        return false;
      }
      if (flsz > 2 * 1024 * 1024 * 1024) {
        this.$message({
          message: '【' + (file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name) + '】 超过2G (使用App最大可至4G)',
          type: 'error'
        });
        return false;
      }
      if (!this.upTokenData) {
        this.$message({
          message: '未获取到token,请刷新页面',
          type: 'error'
        });
        return false;
      }
      return new _promise2.default(function (resolve, reject) {
        var tms = encodeURIComponent(_this3.upTokenData.tms);
        var upths = '' + _this3.upTokenData.host;
        if (!upths.endsWith('/uploadfile')) {
          upths = _this3.upTokenData.host + '/file/uploadfile';
        }
        _this3.uploadActUrl = upths + '?fl1=' + _this3.fenlei + '&amount=' + _this3.amount + '&boxid=' + _this3.boxids + ('&uid=' + _this3.upTokenData.uid + '&tms=' + tms + '&sign=' + _this3.upTokenData.sign);

        _this3.$nextTick(function () {
          return resolve();
        });
      });
    },
    handleError: function handleError(err) {
      this.submiting = false;
      console.log('handleError', err);
      this.$message({
        message: '上传失败！' + err.message || '',
        type: 'error'
      });
    },
    handleSuccess: function handleSuccess(res) {
      this.submiting = false;
      console.log('handleSuccess', res);

      this.$emit('okfun');
    }
  }
};

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			filters: {
				page: 1,
				s: '',
				q: ''
			},
			loading: false,
			total: 0,
			limit: 0,
			listdata: [],
			sels: [] };
	},
	mounted: function mounted() {
		this.getList();
	},

	methods: {
		getList: function getList() {
			var _this = this;

			this.loading = true;

			this.$post('/user/bills', this.filters).then(function (res) {
				console.log(res);
				_this.loading = false;
				_this.listdata = res.data.Data;
				_this.total = res.data.Total;
				_this.limit = res.data.Size;
				_this.filters.page = res.data.Page;
			}).catch(function (err) {
				_this.$message({
					message: err.response.data || '服务器错误',
					type: 'error'
				});
			});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},
		handleAdd: function handleAdd() {},
		handleEdit: function handleEdit() {},
		handleDel: function handleDel() {
			this.$confirm('确定要删除吗?', '提示', {
				type: 'warning'
			}).then(function () {});
		},
		batchRemove: function batchRemove() {}
	}
};

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      formVisible: false,
      formLoading: false,
      formRules: {
        name: [{ required: true, message: '请输入参数' }], newpass: [{ required: true, message: '请输入参数' }, { min: 6, message: '最少六位' }], repass: [{ required: true, message: '请输入参数' }]
      },

      formData: {}
    };
  },

  methods: {
    show: function show() {
      this.formVisible = true;
      this.formData = {
        name: '',
        newpass: '',
        repass: ''
      };
    },
    formSubmit: function formSubmit() {
      var _this = this;

      this.$refs.formd.validate(function (valid) {
        if (valid) {
          if (_this.formData.newpass != _this.formData.repass) {
            _this.$message({
              message: '新密码不一致',
              type: 'error'
            });
            return;
          }
          _this.formLoading = true;
          _this.$post('/user/upname', _this.formData).then(function (res) {
            console.log(res);
            _this.$emit('submitOK');
            _this.formLoading = false;
            _this.formVisible = false;

            _this.$message({
              message: '修改成功!!!',
              type: 'success'
            });
            window.top.location.reload();
          }).catch(function (err) {
            _this.$emit('submitErr', err);
            _this.formLoading = false;

            _this.$message({
              message: err.response ? err.response.data || '服务器错误' : '网络错误',
              type: 'error'
            });
          });
        }
      });
    }
  }
};

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(88);

var _util2 = _interopRequireDefault(_util);

var _txTaxTips = __webpack_require__(434);

var _txTaxTips2 = _interopRequireDefault(_txTaxTips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { txTaxTips: _txTaxTips2.default },
  data: function data() {
    return {
      filters: {
        page: 1,
        s: '',
        q: ''
      },
      loading: false,
      total: 0,
      limit: 0,
      listdata: [],
      sels: [] };
  },
  mounted: function mounted() {
    this.getList();
  },

  methods: {
    getFlSize: _util2.default.getFlSize,
    getList: function getList() {
      var _this = this;

      this.loading = true;

      this.$post('/user/orders', this.filters).then(function (res) {
        console.log(res);
        _this.loading = false;
        _this.listdata = res.data.Data;
        _this.total = res.data.Total;
        _this.limit = res.data.Size;
        _this.filters.page = res.data.Page;
      }).catch(function (err) {
        _this.$message({
          message: err.response.data || '服务器错误',
          type: 'error'
        });
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleAdd: function handleAdd() {},
    handleEdit: function handleEdit() {}
  }
};

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            formVisible: false,
            formLoading: false,
            formRules: {
                pass: [{ required: true, message: '请输入参数' }], newpass: [{ required: true, message: '请输入参数' }, { min: 6, message: '最少六位' }], repass: [{ required: true, message: '请输入参数' }]
            },

            formData: {}
        };
    },

    methods: {
        show: function show() {
            this.formVisible = true;
            this.formData = {
                pass: '',
                newpass: '',
                repass: ''
            };
        },
        formSubmit: function formSubmit() {
            var _this = this;

            this.$refs.formd.validate(function (valid) {
                if (valid) {
                    if (_this.formData.newpass != _this.formData.repass) {
                        _this.$message({
                            message: '新密码不一致',
                            type: 'error'
                        });
                        return;
                    }
                    _this.formLoading = true;
                    _this.$post('/user/uppass', _this.formData).then(function (res) {
                        console.log(res);
                        _this.$emit('submitOK');
                        _this.formLoading = false;
                        _this.formVisible = false;

                        _this.$message({
                            message: '修改密码成功!!!',
                            type: 'success'
                        });
                    }).catch(function (err) {
                        _this.$emit('submitErr', err);
                        _this.formLoading = false;

                        _this.$message({
                            message: err.response ? err.response.data || '服务器错误' : '网络错误',
                            type: 'error'
                        });
                    });
                }
            });
        }
    }
};

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _txTaxTips = __webpack_require__(434);

var _txTaxTips2 = _interopRequireDefault(_txTaxTips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { txTaxTips: _txTaxTips2.default },
  data: function data() {
    return {
      filters: {
        page: 1,
        s: '',
        q: ''
      },
      loading: false,
      total: 0,
      limit: 0,
      listdata: [],
      sels: [] };
  },
  mounted: function mounted() {
    this.getList();
  },

  methods: {
    getList: function getList() {
      var _this = this;

      this.loading = true;

      this.$post('/user/txs', this.filters).then(function (res) {
        console.log(res);
        _this.loading = false;
        _this.listdata = res.data.Data;
        _this.total = res.data.Total;
        _this.limit = res.data.Size;
        _this.filters.page = res.data.Page;
      }).catch(function (err) {
        _this.$message({
          message: err.response.data || '服务器错误',
          type: 'error'
        });
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleAdd: function handleAdd() {},
    handleEdit: function handleEdit() {},
    handleDel: function handleDel() {
      this.$confirm('确定要删除吗?', '提示', {
        type: 'warning'
      }).then(function () {});
    },
    batchRemove: function batchRemove() {},
    revokeBackFun: function revokeBackFun(row) {
      var _this2 = this;

      this.$confirm('确定要撤回提现吗?(每月只能一次)', '提示', {
        type: 'warning'
      }).then(function () {
        _this2.$post('/user/tx-revoke', { xid: row.Xid }).then(function (res) {
          console.log(res);
          _this2.getList();
        }).catch(function (err) {
          _this2.$message({
            message: err.response.data || '服务器错误',
            type: 'error'
          });
        });
      });
    }
  }
};

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(89);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(131);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      formVisible: false,
      formLoading: false,
      formData: {},
      avatseled: false,
      avatimgs: ''
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUserInfo'])),
  mounted: function mounted() {},

  methods: {
    show: function show() {
      this.formVisible = true;
      this.avatseled = false;
      this.avatimgs = this.getUserInfo.avat;
    },
    formSubmit: function formSubmit() {
      var _this = this;

      if (!this.avatseled) {
        this.$message({
          message: '未选择新头像',
          type: 'error'
        });
        return;
      }
      this.formLoading = true;
      this.$post('/user/avat', { imgs: this.avatimgs }).then(function (res) {
        console.log(res);
        _this.$message('操作成功');
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      }).catch(function (err) {
        _this.formLoading = false;

        _this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    changeImg: function changeImg(e) {
      var file = e.target.files[0];
      if (file.size > 1 * 1024 * 1024) {
        this.$message({
          message: '【' + (file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name) + '】 超过1M',
          type: 'error'
        });
        return;
      }
      var that = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        that.avatseled = true;
        that.avatimgs = this.result;
      };
    }
  }
};

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(89);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(131);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var regPhone = /^([0-9]{0,3})[1][3,4,5,7,8,9][0-9]{9}$/;
exports.default = {
  data: function data() {
    return {
      formVisible: false,
      formLoading: false,
      formRules: {
        nick: [{ required: true, message: '请输入参数' }], phone: [{
          validator: function validator(rule, value, callback) {
            if (!value || value == '' || regPhone.test(value)) callback();else callback(new Error('格式错误：必须是 "手机号"'));
          }
        }]
      },

      formData: {}
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUserInfo'])),
  methods: {
    show: function show() {
      this.formVisible = true;
      this.formData = {
        nick: this.getUserInfo.nick,
        desc: this.getUserInfo.desc,
        phone: this.getUserInfo.lxphone,
        wxname: this.getUserInfo.wxname
      };
    },
    formSubmit: function formSubmit() {
      var _this = this;

      this.$refs.formd.validate(function (valid) {
        if (valid) {
          _this.formLoading = true;
          _this.$post('/user/upinfo', _this.formData).then(function (res) {
            console.log(res);
            _this.$emit('submitOK');
            _this.formLoading = false;
            _this.formVisible = false;

            window.top.location.reload();
          }).catch(function (err) {
            _this.$emit('submitErr', err);
            _this.formLoading = false;

            _this.$message({
              message: err.response ? err.response.data || '服务器错误' : '网络错误',
              type: 'error'
            });
          });
        }
      });
    }
  }
};

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var regAmt = /^\d+(\.\d+)?$/;
exports.default = {
    data: function data() {
        return {
            formVisible: false,
            formLoading: false,
            formRules: {
                amt: [{ required: true, message: '请输入金额' }, {
                    validator: function validator(rule, value, callback) {
                        try {
                            if (value == '') {
                                callback(new Error('请输入金额!'));
                            } else if (regAmt.test(value)) {
                                var amt = parseFloat(value);
                                if (amt < 100) callback(new Error('最少提100元'));else if (amt > 50000) callback(new Error('最多提50000元'));else callback();
                            } else callback(new Error('格式错误：必须是 "数字"'));
                        } catch (e) {
                            callback(new Error('格式错误!:必须是 "金额"'));
                        }
                    }
                }]
            },

            formData: {}
        };
    },
    mounted: function mounted() {},

    methods: {
        show: function show() {
            this.formVisible = true;
            this.formData = {
                xid: '',
                amt: '',
                desc: ''
            };
            this.getLastImg();
        },
        formSubmit: function formSubmit() {
            var _this = this;

            this.$refs.formd.validate(function (valid) {
                if (valid) {
                    var regd = /^(data:image).+/;
                    if (_this.formData.xid == '' && _this.formData.imgid == '' && !regd.test(_this.formData.imgs)) {
                        _this.$message({
                            message: '请选择收款码图片',
                            type: 'error'
                        });
                        return;
                    }
                    _this.formLoading = true;
                    _this.$post('/user/tx', _this.formData).then(function (res) {
                        console.log(res);
                        _this.$emit('submitOK');
                        _this.formLoading = false;
                        _this.formVisible = false;
                    }).catch(function (err) {
                        _this.$emit('submitErr', err);
                        _this.formLoading = false;

                        _this.$message({
                            message: err.response ? err.response.data || '服务器错误' : '网络错误',
                            type: 'error'
                        });
                    });
                }
            });
        },
        changeImg: function changeImg(e) {
            var file = e.target.files[0];
            if (file.size > 1 * 1024 * 1024) {
                this.$message({
                    message: '【' + (file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name) + '】 超过1M',
                    type: 'error'
                });
                return;
            }
            var that = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                that.formData.imgid = '';
                that.formData.imgs = this.result;
                that.$forceUpdate();
            };
        },
        getLastImg: function getLastImg() {
            var _this2 = this;

            this.formLoading = true;
            this.$post('/user/tximg').then(function (res) {
                _this2.formLoading = false;
                _this2.formData.imgid = res.data.Id;
                _this2.formData.imgs = res.data.Imgs;
            }).catch(function (err) {
                _this2.formLoading = false;
            });
        }
    }
};

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var regAmt = /^\d+(\.\d+)?$/;
exports.default = {
    data: function data() {
        return {
            formVisible: false,
            formLoading: false,
            formRules: {
                amt: [{ required: true, message: '请输入金额' }, {
                    validator: function validator(rule, value, callback) {
                        try {
                            if (value == '') {
                                callback(new Error('请输入金额!'));
                            } else if (regAmt.test(value)) {
                                var amt = parseFloat(value);
                                if (amt < 100) callback(new Error('最少提100元'));else if (amt > 50000) callback(new Error('最多提50000元'));else callback();
                            } else callback(new Error('格式错误：必须是 "数字"'));
                        } catch (e) {
                            callback(new Error('格式错误!:必须是 "金额"'));
                        }
                    }
                }]
            },

            formData: { infos: {} },

            istips: false,
            showFs: false
        };
    },
    mounted: function mounted() {},

    methods: {
        show: function show() {
            this.formVisible = true;
            this.formLoading = false;
            this.formData = {
                xid: '',
                amt: '',
                desc: '',
                imgid: '',
                imgs: '',
                infos: {
                    fs: 'geren',
                    idname: '',
                    idcard: '',
                    qyname: '',
                    qynum: '',
                    banknum: '',
                    bankaddr: '',
                    aliid: '',
                    aliname: ''
                }
            };
            this.getLastInfos();
        },
        formSubmit: function formSubmit() {
            var _this = this;

            this.$refs.formd.validate(function (valid) {
                if (valid) {
                    if (_this.formData.infos.fs == 'geren') {
                        if (_this.formData.infos.idname == "" || _this.formData.infos.idcard == "") {
                            _this.$message({
                                message: '请填写个人信息',
                                type: 'error'
                            });
                            return;
                        }
                        if (_this.formData.infos.idcard.length < 18 || _this.formData.infos.idcard.length > 20) {
                            _this.$message({
                                message: '身份证有误',
                                type: 'error'
                            });
                            return;
                        }
                        if (_this.formData.infos.banknum == '' || _this.formData.infos.bankaddr == '') {
                            _this.$message({
                                message: '请填写银行信息',
                                type: 'error'
                            });
                            return;
                        }
                    } else if (_this.formData.infos.fs == 'qiye') {
                        if (_this.formData.infos.qyname == "" || _this.formData.infos.qynum == "") {
                            _this.$message({
                                message: '请填写企业信息',
                                type: 'error'
                            });
                            return;
                        }
                        if (_this.formData.infos.qynum.length < 18 || _this.formData.infos.qynum.length > 20) {
                            _this.$message({
                                message: '统一信用码有误',
                                type: 'error'
                            });
                            return;
                        }
                        if (_this.formData.infos.banknum == '' || _this.formData.infos.bankaddr == '') {
                            _this.$message({
                                message: '请填写银行信息',
                                type: 'error'
                            });
                            return;
                        }
                    } else {
                        if (_this.formData.infos.aliid == "" || _this.formData.infos.aliname == "") {
                            _this.$message({
                                message: '请填写支付宝信息',
                                type: 'error'
                            });
                            return;
                        }
                    }
                    _this.formLoading = true;
                    _this.$post('/user/tx-tax', _this.formData).then(function (res) {
                        console.log(res);
                        _this.$emit('submitOK');
                        _this.formLoading = false;
                        _this.formVisible = false;
                    }).catch(function (err) {
                        _this.$emit('submitErr', err);
                        _this.formLoading = false;

                        _this.$message({
                            message: err.response ? err.response.data || '服务器错误' : '网络错误',
                            type: 'error'
                        });
                    });
                }
            });
        },
        changeImg: function changeImg(e) {
            var file = e.target.files[0];
            if (file.size > 2 * 1024 * 1024) {
                this.$message({
                    message: '【' + (file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name) + '】 超过2M',
                    type: 'error'
                });
                return;
            }
            var that = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                that.formData.imgid = '';
                that.formData.imgs = this.result;
            };
        },
        getLastInfos: function getLastInfos() {
            var _this2 = this;

            this.formLoading = true;
            this.$post('/user/tx-taxs').then(function (res) {
                _this2.formLoading = false;
                if (res.data.infos && res.data.infos.fs && res.data.infos.fs != '') _this2.formData.infos = res.data.infos;
                if (res.data.txstat == 1) {
                    _this2.showFs = true;_this2.istips = true;
                }
                if (res.data.txstat == 5) {
                    _this2.showFs = false;
                    _this2.istips = true;
                    _this2.formData.infos.fs = 'ali';
                }
                _this2.$forceUpdate();
            }).catch(function (err) {
                _this2.formLoading = false;
            });
        }
    }
};

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            formVisible: false,

            infos: ''
        };
    },
    mounted: function mounted() {},

    methods: {
        show: function show(infos) {
            if (!infos || infos == '') {
                return;
            }
            var info = JSON.parse(infos);
            this.formVisible = true;
            this.infos = info;
        }
    }
};

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(460);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(34);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(464);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(461);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(462);

var _store = __webpack_require__(297);

var _store2 = _interopRequireDefault(_store);

var _router = __webpack_require__(459);

var _router2 = _interopRequireDefault(_router);

var _mock = __webpack_require__(458);

var _mock2 = _interopRequireDefault(_mock);

__webpack_require__(463);

var _apis = __webpack_require__(296);

var _apis2 = _interopRequireDefault(_apis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_mock2.default.bootstrap();


_vue2.default.use(_elementUi2.default);

_vue2.default.prototype.$post = _apis2.default.post;
_vue2.default.prototype.$ApiUrl = _apis2.default.apiUrl;
new _vue2.default({
  router: _router2.default,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Users = exports.LoginUsers = undefined;

var _mockjs = __webpack_require__(1118);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginUsers = [{
  id: 1,
  username: 'admin',
  password: '123456',
  avatar: 'https://raw.githubusercontent.com/taylorchen709/markdown-images/master/vueadmin/user.png',
  name: '张某某'
}];

var Users = [];

for (var i = 0; i < 86; i++) {
  Users.push(_mockjs2.default.mock({
    id: _mockjs2.default.Random.guid(),
    name: _mockjs2.default.Random.cname(),
    addr: _mockjs2.default.mock('@county(true)'),
    'age|18-60': 1,
    birth: _mockjs2.default.Random.date(),
    sex: _mockjs2.default.Random.integer(0, 1)
  }));
}

exports.LoginUsers = LoginUsers;
exports.Users = Users;

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(540);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(210);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(208);

var _axios2 = _interopRequireDefault(_axios);

var _axiosMockAdapter = __webpack_require__(488);

var _axiosMockAdapter2 = _interopRequireDefault(_axiosMockAdapter);

var _user = __webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _Users = _user.Users;

exports.default = {
  bootstrap: function bootstrap() {
    var mock = new _axiosMockAdapter2.default(_axios2.default);

    mock.onGet('/success').reply(200, {
      msg: 'success'
    });

    mock.onGet('/error').reply(500, {
      msg: 'failure'
    });

    mock.onPost('/login').reply(function (config) {
      var _JSON$parse = JSON.parse(config.data),
          username = _JSON$parse.username,
          password = _JSON$parse.password;

      return new _promise2.default(function (resolve, reject) {
        var user = null;
        setTimeout(function () {
          var hasUser = _user.LoginUsers.some(function (u) {
            if (u.username === username && u.password === password) {
              user = JSON.parse((0, _stringify2.default)(u));
              user.password = undefined;
              return true;
            }
          });

          if (hasUser) {
            resolve([200, { code: 200, msg: '请求成功', user: user }]);
          } else {
            resolve([200, { code: 500, msg: '账号或密码错误' }]);
          }
        }, 1000);
      });
    });

    mock.onGet('/user/list').reply(function (config) {
      var name = config.params.name;

      var mockUsers = _Users.filter(function (user) {
        if (name && user.name.indexOf(name) == -1) return false;
        return true;
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            users: mockUsers
          }]);
        }, 1000);
      });
    });

    mock.onGet('/user/listpage').reply(function (config) {
      var _config$params = config.params,
          page = _config$params.page,
          name = _config$params.name;

      var mockUsers = _Users.filter(function (user) {
        if (name && user.name.indexOf(name) == -1) return false;
        return true;
      });
      var total = mockUsers.length;
      mockUsers = mockUsers.filter(function (u, index) {
        return index < 20 * page && index >= 20 * (page - 1);
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            total: total,
            users: mockUsers
          }]);
        }, 1000);
      });
    });

    mock.onGet('/user/remove').reply(function (config) {
      var id = config.params.id;

      _Users = _Users.filter(function (u) {
        return u.id !== id;
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '删除成功'
          }]);
        }, 500);
      });
    });

    mock.onGet('/user/batchremove').reply(function (config) {
      var ids = config.params.ids;

      ids = ids.split(',');
      _Users = _Users.filter(function (u) {
        return !ids.includes(u.id);
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '删除成功'
          }]);
        }, 500);
      });
    });

    mock.onGet('/user/edit').reply(function (config) {
      var _config$params2 = config.params,
          id = _config$params2.id,
          name = _config$params2.name,
          addr = _config$params2.addr,
          age = _config$params2.age,
          birth = _config$params2.birth,
          sex = _config$params2.sex;

      _Users.some(function (u) {
        if (u.id === id) {
          u.name = name;
          u.addr = addr;
          u.age = age;
          u.birth = birth;
          u.sex = sex;
          return true;
        }
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '编辑成功'
          }]);
        }, 500);
      });
    });

    mock.onGet('/user/add').reply(function (config) {
      var _config$params3 = config.params,
          name = _config$params3.name,
          addr = _config$params3.addr,
          age = _config$params3.age,
          birth = _config$params3.birth,
          sex = _config$params3.sex;

      _Users.push({
        name: name,
        addr: addr,
        age: age,
        birth: birth,
        sex: sex
      });
      return new _promise2.default(function (resolve, reject) {
        setTimeout(function () {
          resolve([200, {
            code: 200,
            msg: '新增成功'
          }]);
        }, 500);
      });
    });
  }
};

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLgInfo = undefined;

var _promise = __webpack_require__(210);

var _promise2 = _interopRequireDefault(_promise);

var _apis = __webpack_require__(296);

var _apis2 = _interopRequireDefault(_apis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLgInfo = exports.getLgInfo = function getLgInfo(_ref) {
    var commit = _ref.commit;

    return new _promise2.default(function (resolve, reject) {
        _apis2.default.post('/lg/info').then(function (res) {
            commit('SET_LGINFO', res.data);
            resolve();
        }).catch(function (err) {
            reject(err);
        });
    });
};

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getUserInfo = exports.getUserInfo = function getUserInfo(state) {
    return state.userinfo;
};

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SET_LGINFO = exports.SET_LGINFO = function SET_LGINFO(state, par) {
    if (par) state.userinfo = par;else state.userinfo = {};
};

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    },
    getFlSize: function getFlSize(size) {
        var rets = "0K";
        if (size == null || size <= 0) return rets;
        if (size >= 1073741824) rets = (parseFloat(size) / 1073741824).toFixed(2) + "G";else if (size >= 1048576) rets = (parseFloat(size) / 1048576).toFixed(2) + "M";else if (size >= 1024) rets = (parseFloat(size) / 1024).toFixed(2) + "K";else rets = size + "B";
        return rets;
    }
};

/***/ })

},[533]);


// WEBPACK FOOTER //
// static/js/app.fe7ffa8256ff4fc5b77c.js